import { Avatar, Button, Grid, Grid2, InputAdornment, MenuItem, Select, TextField, Typography , Box , LinearProgress, Snackbar, Switch, Modal,Tooltip} from "@mui/material";
import Navbar from "../navbar/Navbar";
import Sidemenu from "../sidemenu/Sidemenu";
import { GoogleMap, LoadScript, Marker, Polyline, useJsApiLoader } from '@react-google-maps/api';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import mapPin from '../../assets/icons/LocationPin.svg';
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import dropMarker from '../../assets/icons/DropIcon.svg';
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import vehicleTypeCar from '../../assets/images/vehicleTypeCar.svg';
import vehicletypeAuto from '../../assets/images/vehicletypeAuto.svg';
import vehicleTypeBike from '../../assets/images/vehicleTypeBike.svg';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import AutoMarker from '../../assets/images/AutoMarker.svg';
import BikeMarker from '../../assets/images/bikeMarker.svg';
import SubtractCircleSvg from '../../assets/images/subtractCircleSvg.svg';
import CarMarker from '../../assets/images/carMarker.svg';
import useChunkedRideData from '../useChunkedRideData.js';
import RideRequestComponent from '../dispatcherCommon.jsx';
import axios from "axios";
import TokenError from "../tokenError";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import altAvatar from '../../assets/images/altAvatar.svg';
import Lottie from "lottie-react";
import loadingAnimation from "../../assets/animations/Ride Finding Animation.json";
import CarDriver from '../../assets/images/CabDriver.svg';
import successIcon from '../../assets/images/Sucessicon.svg';
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";
import { Label } from "flowbite-react";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DriverLabelMarker from './DriverLabelMarker';
import MerchantParcelForm from "./MerchantPanelForm";
import { buildParcelBody, clean } from "../../utils/MerchantParcelUtils";


const LIBRARIES = ["maps", "drawing", "places", "geometry"];
var constants = require('../../constant');

const styles = {
    errorBox: {
      backgroundColor: '#EFFBF7',
      color: '#0DBA78',
      border: '1px solid #0DBA78',
      paddingLeft: '10%',
      paddingRight: '10%',
      borderRadius: '5px',
      marginTop: '6px'
    }
};

const Dispatcher = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const autosUrl = config.autosUrl;
    const user_image="bgrss";
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));
    const add_pool_users = Number(localStorage.getItem('add_pool_users') || 0);
    const is_driver_debt_limit_enabled = localStorage.getItem('is_driver_debt_limit_enabled') || 0;
    const merchantIdFromLocal = Number(localStorage.getItem('merchantId')) || 0;
    const isMerchantMode = merchantIdFromLocal != 0;
    
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [debtLimit, setDebtLimit] = useState(cities[0].driver_debt_limit);
    console.log("debtLimit", debtLimit);

    const handleFilterChange = (filterType, value) => {    //handle the city filter
        if (filterType === 'city'){
            setCityFilter(value);
            const selectedCity = cities.find(city => city.city_id === value);
            if (selectedCity) {
                setDebtLimit(selectedCity.driver_debt_limit);
            }
        } 
    };

    const [pickupLocation, setPickupLocation] = useState('');
    const [pickupLatLng, setPickupLatLng] = useState(null);

    const [dropLocation, setDropLocation] = useState('');
    const [dropLatLng, setDropLatLng] = useState(null);

    const clientId = localStorage.getItem('clientId');
    const [searchByClient, setSearchByClient] = useState(clientId==188 ? true : false);
    const [userCodeSearch, setUserCodeSearch] = useState('');
    const [pickupDropLocation, setPickupDropLocation] = useState('');
    const [pickupDropLatLng, setPickupDropLatLng] = useState(null);
    const corporateId = localStorage.getItem('corporateId');
    const [creatingOrder, setCreatingOrder] = useState(false);
    const [orderCreated, setOrderCreated] = useState(null);
    
    // State for managing stops
    const [stops, setStops] = useState([]);

    const [stopIds, setStopIds] = useState([{ 
        address: '', 
        latitude: '', 
        longitude: '', 
        stop_id: 1,
        locationId: ''  // Add this line
    }]);

    const [selectedStopIndex, setSelectedStopIndex] = useState(null);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [autoCancel, setAutoCancel] = useState(false);
    const [ongoingRideCheck, setOngoingRideCheck] = useState(false);
    const [ongoingRideCheckMessage, setOngoingRideCheckMessage] = useState('');
    const [addClientModal, setAddClientModal] = useState(false);
    const [seatCount, setSeatCount] = useState('');
    const [additionalUserIds, setAdditionalUserIds] = useState([]);
    const [modalCustomerPhone, setModalCustomerPhone] = useState('');
    const [modalUserCodeSearch, setModalUserCodeSearch] = useState('');
    const [modalSearchByClient, setModalSearchByClient] = useState(true);
    const [forceAssignFlag, setForceAssignFlag] = useState(false);
    const [userStopMapping, setUserStopMapping] = useState({});
    const [initialcityCenter, setInitialcityCenter] = useState();
    const [corporateFarePerRide, setCorporateFarePerRide] = useState('');
    const [selectedUserId, setSelectedUserId] = useState('');
    const [userRemainingTrips, setUserRemainingTrips] = useState('');
    const [userRemainingBalance, setUserRemainingBalance] = useState('');

    const [modalUSerId, setModalUSerId] = useState('');
    const [modalUserName, setModalUserName] = useState('');
    const [modalPickupDropLocData, setModalPickupDropLocData] = useState([]);
    const [modalWayPoints, setModalWayPoints] = useState([]);
    const [flagFetchingStops, setFlagFetchingStops] = useState(false);
    const [eligibilityLoading, setEligibilityLoading] = useState(false);

    const [merchantForm, setMerchantForm] = useState(null);
    const [findingVehicles, setFindingVehicles] = useState(false);

    const resetVehicles = () => {
        setVehicleDetails([]);
        setVehicleId('');
        setVehicleType('');
        setMerchantForm(null);
    };

    // Route changed: old vehicles/fares are no longer valid
    const stopsSig = stops.map(s => `${s.latitude},${s.longitude}`).join('|');
    useEffect(() => {
        if (isMerchantMode) resetVehicles();
    }, [pickupLatLng, dropLatLng, stopsSig]);
    
    const hasCorporate = corporateId && corporateId !== '0' && corporateId !== 'undefined' && corporateId !== 'null';
    
    // Button stays disabled while the check is pending, but no banner is shown
    const scheduleDisabledReason = (() => {
        // if (!eligibilityReady) return '';
        if (Number(userRemainingTrips) <= 0) return 'This user has no remaining corporate trips for the month.';
        if (Number(userRemainingBalance) < Number(corporateFarePerRide)) {
            return `Insufficient corporate balance. Remaining: ${Number(userRemainingBalance).toFixed(2)}, fare: ${Number(corporateFarePerRide).toFixed(2)}.`;
        }
        return '';
    })();
    const eligibilityReady = hasCorporate && !eligibilityLoading
    && userRemainingTrips !== '' && userRemainingBalance !== '' && corporateFarePerRide !== '';
    const isScheduleDisabled = eligibilityReady && scheduleDisabledReason !== '';
    const isScheduleButtonDisabled = isScheduleDisabled || (hasCorporate && !eligibilityReady);
    const map_search_zone = localStorage.getItem('map_search_zone');
    
    // Generate a sequential stop ID (1, 2, 3) based on current stops length
    const getNextStopId = () => {
        // Current stops length + 1 will give us 1, 2, 3 for the sequence
        return stops.length + 1;
    };
    
    // Ensure stopIds always have sequential stop_id values
    const reindexStopIds = (list) => list.map((s, i) => ({ ...s, stop_id: i + 1 }));
    
    // Handler for adding a new stop
    const handleAddStop = () => {
        if(stops.length >= 3){
            setMessage('Maximum 3 stops are allowed');
            showSnackbar(true);
            return;
        }
        // Assign a unique stop_id when creating the stop
        setStops([...stops, { 
            address: '', 
            latitude: '', 
            longitude: '', 
            stop_id: getNextStopId(),
            // display_index: stops.length + 1 // For UI display purposes
        }]);
    };
    // Debug effect for userStopMapping changes
    useEffect(() => {
        console.log('userStopMapping updated:', userStopMapping);
    }, [userStopMapping]);
    
    // Handler for updating a stop's location
    const handleStopLocationChange = (index, value) => {
        setStops(prevStops => prevStops.map((s, i) =>
            i === index ? { ...s, address: value, latitude: '', longitude: '' } : s
        ));
        setVehicleId('');
        setVehicleType('');
    };

    // Handler for selecting a stop in the textfield
    const handleStopFocus = (index) => {
        setSelectedStopIndex(index);
    };

    // Handler for setting stop's lat/lng after selection from autocomplete
    // const handleStopLatLngUpdate = (index, latLng) => {
    //     const updatedStops = [...stops];
    //     updatedStops[index].latLng = latLng;
    //     setStops(updatedStops);
        
    //     // Update polyline with all points
    //     updatePolylineWithStops();
    // };

    // Handler for removing a stop
    const handleRemoveStop = (indexToRemove) => {
        
        // Use functional update to ensure we're working with the latest state
        setStops(currentStops => {
            // Make a clean copy of the stops array
            const beforeStop = currentStops.slice(0, indexToRemove);
            const afterStop = currentStops.slice(indexToRemove + 1);
            const newStops = [...beforeStop, ...afterStop];
            setVehicleId('');
            setVehicleType('');
            
            // Update display indices
            const updatedStops = newStops.map((stop, i) => ({
                ...stop,
                // display_index: i + 1,
                stop_id: i + 1,
            }));
            
            // Schedule polyline update if needed
            setTimeout(() => {
                if (pickupLatLng && dropLatLng && updatedStops.some(stop => stop.latitude && stop.longitude)) {
                    updatePolylineWithStops();
                } else if (pickupLatLng && dropLatLng) {
                    fetchDirections();
                }
            }, 100);
            
            return updatedStops;
        });
    };

    const [driversData, setDriversData] = useState([]);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isNearbyDrivers, setIsNearbyDrivers] = useState(false);
    const [phone, setPhone] = useState();
    const [userByPhone, setUserByPhone] = useState('');
    const [vehicleType, setVehicleType] = useState('');
    const [vehicleDetails, setVehicleDetails] = useState([]);
    const [fullScreenLoader, setFullScreenLoader] = useState(false);
    const [responseFlag, setResponseFlag] = useState(null); 

    const [autoRideAssigned, setAutoRideAssigned] = useState(false);
    const [noDriverFound, setNoDriverFound] = useState(false);
    const [assignGridData, setAssignGridData] = useState([]);
    const [normalAssign, setNormalAssign] = useState(false);
    const [noServiceAvailable, setNoServiceAvailable] = useState(false);
    const [vehicleId, setVehicleId] = useState('');
    const [pickupLocationData, setPickupLocationData] = useState([]);
    const [dropLocationData, setDropLocationData] = useState([]);
    const [pickupDropLocationData, setPickupDropLocationData] = useState([]);
    const country_code = localStorage.getItem('default_country_iso_code');

    // Create refs for the input fields
    const inputRef = useRef(null);   //pickup
    const inputDropRef = useRef(null);    //drop
    const stopRefs = useRef([]);    //refs for stop fields
    const panel_customer_specific_address = localStorage.getItem('panel_customer_specific_address');
    const remove_add_stops = localStorage.getItem('remove_add_stops');
    const [parcelTypes, setParcelTypes] = useState([]);

    const [merchantParcelData, setMerchantParcelData] = useState({
        sender: null,
        recipient: null,
        stops: [],
    });

    // const loaderOptions = {
    //     id: 'google-map-script',
    //     googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
    //     libraries: LIBRARIES,
    // }
    
    const { isLoaded, loadError } = useGoogleMapsLoader();

    useEffect(() => {   //autocomplete api of google
        const loadAutocomplete = () => {
            if (window.google && window.google.maps && window.google.maps.places) {
                // Autocomplete for pickup location
                const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
                    types: ['geocode', 'establishment'], // You can modify types depending on your use case
                    ...(map_search_zone ? { componentRestrictions: { country: map_search_zone || 'IN' } } : {})
                    // componentRestrictions: { country: 'IN' }, // Optional: Restrict results to a specific country
                });
        
                // Add an event listener for when the place is selected
                autocomplete.addListener('place_changed', () => {
                    const place = autocomplete.getPlace();
                    if (place.geometry) {
                        setPickupLatLng({
                            lat: place.geometry.location.lat(),
                            lng: place.geometry.location.lng(),
                        });
                        if (place.address_components && Array.isArray(place.address_components)) {
                            const filteredComponents = place.address_components
                                .map(comp => comp.long_name)
                                .filter(name => {
                                    // Remove plus codes like WRGM+RPV and similar
                                    return !/^[A-Z0-9]{4,}\+[A-Z0-9]{2,}$/.test(name);
                                });
                
                            const address = filteredComponents.join(', ');
                            setPickupLocation(address);
                        } else {
                            setPickupLocation(''); // Don't use formatted_address fallback
                        }
                        setVehicleId('');
                        setVehicleType('');
                    }
                });

                // Autocomplete for drop location
                const autocompleteDrop = new window.google.maps.places.Autocomplete(inputDropRef.current, {
                    types: ['geocode', 'establishment'],
                    ...(map_search_zone ? { componentRestrictions: { country: map_search_zone || 'IN' } } : {})
                    // componentRestrictions: { country: 'IN' },
                });
                autocompleteDrop.addListener('place_changed', () => {
                    const place = autocompleteDrop.getPlace();
                    if (place.geometry) {
                        setDropLatLng({
                            lat: place.geometry.location.lat(),
                            lng: place.geometry.location.lng(),
                        });
                        setDropLocation(place.formatted_address || '');
                        setVehicleId('');
                        setVehicleType('');
                    }
                });
                
                // Setup autocomplete for all existing stop fields
                stopRefs.current.forEach((ref, index) => {
                    if (ref) {
                        const autocompleteStop = new window.google.maps.places.Autocomplete(ref, {
                            types: ['geocode', 'establishment'],
                            ...(map_search_zone ? { componentRestrictions: { country: map_search_zone || 'IN' } } : {})
                            // componentRestrictions: { country: 'IN' },
                        });
                        autocompleteStop.addListener('place_changed', () => {
                            const place = autocompleteStop.getPlace();
                            if (place.geometry) {
                                setStops(prev => prev.map((s, i) => i === index ? {
                                    ...s,
                                    address: place.formatted_address || '',
                                    latitude: place.geometry.location.lat(),
                                    longitude: place.geometry.location.lng(),
                                } : s));
                                setVehicleId('');
                                setVehicleType('');
                            }
                        });
                    }
                });
            }
        };

        loadAutocomplete();
    }, [isLoaded, stops.length]);

    const [directions, setDirections] = useState(null);
    const [routePath, setRoutePath] = useState([]);
    const [rideDistance, setRideDistance] = useState(0);
    const [estimatedFare, setEstimatedFare] = useState(0);
    const [pickupAddress, setPickupAddress] = useState('');
    const [dropAddress, setDropAddress] = useState('');
    const [data, setData] = useState([]);  // Holds the cumulative data
    const [loading, setLoading] = useState(false);  // Loading state
    const [error, setError] = useState(null);  // Error state
    const [hasMore, setHasMore] = useState(true);
    const [autoAssignParams, setAutoAssignParams] = useState({});
    const [normalAssignParams, setNormalAssignParams] = useState({});
    const [autoAssigning, setAutoAssigning] = useState(false);
    const [polyLine, setPolyLine] = useState('');
    const [gridData,setGridData] = useState('');
    const [showForceAssignedSuccess,setShowForceAssignedSuccess] = useState(false);
    const [forceAssignData, setForceAssignData] = useState('');
    const [rideEta, setRideEta] = useState(0);
    const [selectedFareObj, setSelectedFareObj] = useState('');
    const [adminid,setadminid] = useState(localStorage.getItem('admin_id'));
    const [merchantUserId, setMerchantUserId] = useState(null);

    // Function to update polyline with all points (pickup, stops, drop)
    const updatePolylineWithStops = () => {
        // Check if we have at least a pickup location
        if (!pickupLatLng) return;
        
        // Filter out stops that don't have coordinates yet
        const validStops = stops.filter(stop => stop.latitude && stop.longitude);
        
        // Sort the stops by their stop_id to ensure sequential order
        const sortedStops = [...validStops].sort((a, b) => a.stop_id - b.stop_id);
        
        // If no pickup and no valid stops, nothing to do
        if (sortedStops.length === 0 && !dropLatLng) {
            return;
        }
        
        // If only pickup and drop (no stops), use simple directions
        if (sortedStops.length === 0 && dropLatLng) {
            fetchDirections();
            return;
        }
        
        // Create waypoints for all stops in the correct order
        const waypoints = sortedStops.map(stop => ({
            location: new window.google.maps.LatLng(stop.latitude, stop.longitude),
            stopover: true // Ensures the route actually passes through this point
        }));
        
        const directionsService = new window.google.maps.DirectionsService();
        
        // Always use drop location as destination when available
        const destination = dropLatLng 
            ? new window.google.maps.LatLng(dropLatLng.lat, dropLatLng.lng)
            : new window.google.maps.LatLng(sortedStops[sortedStops.length - 1].latitude, sortedStops[sortedStops.length - 1].longitude);
        
        // If we're using the last stop as destination, remove it from waypoints to avoid duplicating it
        const adjustedWaypoints = dropLatLng ? waypoints : waypoints.slice(0, -1);
        
        // Log the sequence to verify the order
        console.log('Route sequence:', {
            origin: 'Pickup',
            waypoints: adjustedWaypoints.map((wp, i) => `Stop ${i+1}`),
            destination: dropLatLng ? 'Drop' : `Stop ${sortedStops.length}`
        });
        
        const request = {
            origin: new window.google.maps.LatLng(pickupLatLng.lat, pickupLatLng.lng),
            destination: destination,
            waypoints: adjustedWaypoints,
            optimizeWaypoints: false, // Keep the order of stops exactly as specified
            travelMode: window.google.maps.TravelMode.DRIVING,
            provideRouteAlternatives: false,
            avoidHighways: false,
            avoidTolls: false
        };
        
        directionsService.route(request, (result, status) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
                setPolyLine(result.routes[0].overview_polyline);
                
                // Sum up distance from all legs
                let totalDistance = 0;
                let totalDuration = 0;
                
                // Extract the path points from all legs to create a single path
                const path = [];
                
                result.routes[0].legs.forEach(leg => {
                    totalDistance += leg.distance.value;
                    totalDuration += (leg.duration.value)/60;
                    
                    // Add all steps' points to our path
                    leg.steps.forEach(step => {
                        // Decode the path points from each step
                        const pathPoints = window.google.maps.geometry.encoding.decodePath(
                            step.polyline.points
                        );
                        
                        // Add each point to our path array (but skip first point after the first step
                        // to avoid duplicates where steps connect)
                        pathPoints.forEach((point, idx) => {
                            if (idx > 0 || path.length === 0) {
                                path.push({ lat: point.lat(), lng: point.lng() });
                            }
                        });
                    });
                });
                
                // Set the complete path for our single polyline
                setRoutePath(path);
                
                setRideDistance(totalDistance);
                setRideEta(totalDuration);
                setPickupAddress(result.routes[0].legs[0].start_address);
                setDropAddress(result.routes[0].legs[result.routes[0].legs.length - 1].end_address);
                setDirections(result);
            } else {
                console.error("Directions request failed due to " + status);
            }
        });
    };

    const fetchDirections = () => {
        if (pickupLatLng && dropLatLng) {
            const directionsService = new window.google.maps.DirectionsService();
            const request = {
                origin: pickupLatLng,
                destination: dropLatLng,
                travelMode: window.google.maps.TravelMode.DRIVING, // or WALKING, BICYCLING, etc.
            };
            directionsService.route(request, (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    setPolyLine(result.routes[0].overview_polyline);
                    setRideDistance(result.routes[0].legs[0].distance.value);
                    setPickupAddress(result.routes[0].legs[0].start_address);
                    setDropAddress(result.routes[0].legs[0].end_address);
                    setRideEta((result.routes[0].legs[0].duration.value)/60);
                    // Extract the path points for our single polyline
                    const path = [];
                    result.routes[0].legs[0].steps.forEach(step => {
                        // Decode the path points
                        const points = window.google.maps.geometry.encoding.decodePath(
                            step.polyline.points
                        );
                        
                        // Add each point to our path array
                        points.forEach((point, idx) => {
                            if (idx > 0 || path.length === 0) {
                                path.push({ lat: point.lat(), lng: point.lng() });
                            }
                        });
                    });
                    
                    // Set the path for our single polyline
                    setRoutePath(path);
                    setDirections(result);
                } else {
                    console.error("Directions request failed due to " + status);
                }
            });
        }
    };

    useEffect(()=>{
        const citycenter = cities.find((cityObj) => cityObj.city_id === cityFilter);
        if (citycenter?.center_latitude && citycenter?.center_longitude) {
            const geocenter = {
                lat: Number(citycenter?.center_latitude),
                lng: Number(citycenter?.center_longitude)
            };
            setInitialcityCenter(geocenter);
        }
    },[cityFilter])

    const fetchParcelTypes = async () => {
        try {
            const token = localStorage.getItem('token');
            const url = autosUrl + '/customer/get_parcel_types';
            const timestamp = new Date().getTime();
            const body = {
                is_panel_request: 1,
                client_id: clientId,
                city_id: cityFilter,
                // timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
    
            if (response.flag == 200) {
                setParcelTypes(Array.isArray(response.data) ? response.data : []);
            } else if (response.flag == 102) {
                console.log('Token is expired. Please login again');
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => navigate('/signup'), 2000);
            } else {
                setParcelTypes([]);
            }
        } catch (error) {
            console.log('error', error);
            setParcelTypes([]);
        }
    };
    
    // Only merchants use parcels; refetch when the city changes
    useEffect(() => {
        if (isMerchantMode && cityFilter) {
            fetchParcelTypes();
        }
    }, [cityFilter]);

    const [map, setMap] = useState(null)
    // Convert containerStyle to state so it can be changed when Fetch Details is clicked
    const [containerStyle, setContainerStyle] = useState({
        width: '100%',
        height: merchantIdFromLocal ? 'calc(100vh - 160px)' : '500px',
    });
    const center = {
        // lat: 28.644800, lng: 77.216721
        lat: pickupLatLng ? pickupLatLng.lat : 28.644800, 
        lng: pickupLatLng ? pickupLatLng.lng : 77.216721
    };
    
    const onLoad = React.useCallback((map) => {
        // console.log('Map loaded successfully');
        setMap(map); // Store the map instance
    }, []);
    
    // Update route path and markers when stops or locations change
    useEffect(() => {
        if (!map || (!pickupLatLng && !dropLatLng)) return;

        const bounds = new window.google.maps.LatLngBounds();
        const directionsService = new window.google.maps.DirectionsService();
        const waypoints = [];

        // Add waypoints for stops in the explicit stop_id order
        const orderedStops = [...stopIds].sort((a, b) => (a.stop_id || 0) - (b.stop_id || 0));
        orderedStops.forEach(stopId => {
            const matchingLocation = pickupDropLocationData.find(loc => loc.id === stopId?.locationId);
            if (matchingLocation?.latitude && matchingLocation?.longitude) {
                waypoints.push({
                    location: new window.google.maps.LatLng(
                        parseFloat(matchingLocation.latitude),
                        parseFloat(matchingLocation.longitude)
                    ),
                    stopover: true
                });
            }
        });

        const request = {
            origin: pickupLatLng,
            destination: dropLatLng,
            waypoints: waypoints,
            travelMode: window.google.maps.TravelMode.DRIVING,
            // Keep waypoints order in sync with UI sequence
            optimizeWaypoints: false
        };

        directionsService.route(request, (result, status) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
                // Set the overview path for the polyline
                const path = result.routes[0].overview_path.map(latLng => ({
                    lat: latLng.lat(),
                    lng: latLng.lng()
                }));
                
                setRoutePath(path);
                
                // Update bounds to include all points
                path.forEach(point => {
                    bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
                });
                
                // Fit map to show the entire route with padding
                if (!bounds.isEmpty()) {
                    map.fitBounds(bounds, { padding: 50 });
                }
                
                // Update distance and ETA if needed
                let totalDistance = 0;
                let totalDuration = 0;
                
                result.routes[0].legs.forEach(leg => {
                    totalDistance += leg.distance.value;
                    totalDuration += leg.duration.value / 60;
                });
                
                setRideDistance(totalDistance);
                setRideEta(totalDuration);
            }
        });
        
        // Cleanup function
        return () => {
            // Cleanup if needed
        };
    }, [pickupLatLng, dropLatLng, stopIds, pickupDropLocationData, map]);
    
    useEffect(() => {
        // Ensure the map is loaded before trying to fit bounds
        if (!map) {
            console.warn('Map is not loaded yet');
            return;
        }
    
        // Ensure driversData contains valid data
        if (driversData.length > 0) {
    
            try {
                const bounds = new window.google.maps.LatLngBounds();
    
                driversData.forEach((marker) => {
                    if (marker.current_latitude && marker.current_longitude) {
                        bounds.extend(new window.google.maps.LatLng(marker.current_latitude, marker.current_longitude));
                        if(pickupLatLng){
                            bounds.extend(new window.google.maps.LatLng(pickupLatLng.lat, pickupLatLng.lng));
                        }
                        if(dropLatLng){
                            bounds.extend(new window.google.maps.LatLng(dropLatLng.lat, dropLatLng.lng));
                        }
                    } else {
                        console.warn('Invalid marker data:', marker);
                    }
                });
    
                // Apply bounds only if valid
                map.fitBounds(bounds);
            } catch (error) {
                console.error('Error fitting map bounds:', error);
            }
        }
    }, [map, driversData, userByPhone]);
    
    
    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, []);
    
    useEffect(() => {
        // If we have a pickup location
        if (pickupLatLng) {
            const validStops = stops.filter(stop => stop.latitude && stop.longitude);
            
            // Case 1: We have pickup, at least one stop, and optionally a drop location
            if (validStops.length > 0) {
                updatePolylineWithStops(); // Draw polyline through all points
            } 
            // Case 2: We have pickup and drop but no stops
            else if (dropLatLng) {
                fetchDirections(); // Direct route without stops
            }
            // Case 3: We only have pickup, no stops or drop yet - nothing to draw
        }
    }, [pickupLatLng, dropLatLng, stops]);
    
    // Trigger polyline update when stops change
    useEffect(() => {
        if (pickupLatLng && dropLatLng && stops.some(stop => stop.latitude && stop.longitude)) {
            updatePolylineWithStops();
        }
    }, [stops]);
    
    const fetchCityDrivers = async () => {
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            // const url = `${serverUrl}/driver/fetch_city_driver`;
            const url = serverUrl + "/driver/city_online_driver"
            const obj={
                token: token, 
                timestamp: timestamp,
                city_id: cityFilter
            }
            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 200){
                const cityDriversData = response.data;
                setDriversData(cityDriversData);
            }
            else if(response.flag ===411){
                setDriversData([]);
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        fetchCityDrivers();
    }, [cityFilter])

    useEffect(() => {
        if(userByPhone.user_id)
        fetchAddress();
    },[userByPhone])

    useEffect(() => {
        if(modalUSerId){
            console.log('modalUSerId', modalUSerId);
            fetchModalAddress();
        }
    },[modalUSerId])

    const fetchModalAddress = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/customer/fetch_specific_address';
            const timestamp = new Date().getTime();
            const body1 = {
                token: token,
                user_id: modalUSerId,
                address_type: 1,
                timestamp: timestamp
            };
            const body2 = {
                token: token,
                user_id: modalUSerId,
                address_type: 2,
                timestamp: timestamp
            }
            const response =  await makeGetRequestToUrl(url, body1);
            const response2 = await makeGetRequestToUrl(url, body2);
            let both = [];
            if(response.flag==200){
                // setPickupLocationData(response.data);
                both.push(...response.data)
            }
            if(response2.flag==200){
                // setDropLocationData(response2.data);
                both.push(...response2.data)
            }
            console.log('both', both);
            setModalPickupDropLocData(both);

            if(response.flag==102 || response2.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    const findNearbyDrivers = async(formArg) =>{
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/customer/find_nearby_drivers`;
            const body={
                token: token, 
                // timestamp: timestamp, 
                is_panel_request:1, 
                ride_distance: rideDistance/1000,
                ride_eta: rideEta,
                pickup_latitude: String(pickupLatLng.lat),
                pickup_longitude: String(pickupLatLng.lng),
                drop_latitude: String(dropLatLng.lat),
                drop_longitude: String(dropLatLng.lng),
                encoded_polyline: String(polyLine),
                city_id: cityFilter
            }
            if (isMerchantMode) {
                const f = formArg || merchantForm;
                if (!f) return;
                Object.assign(body, { is_parcel: 1 }, buildParcelBody(f));
            }

            const response =  await makePostRequestToUrl(url, body);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            else if(response.flag == 200){
                const vehicleDetails = response.data.vehicle_details;
                const driversData = [];
                setVehicleDetails(vehicleDetails);
                for(var i=0;i<vehicleDetails.length;i++){
                    for(var j=0;j<vehicleDetails[i].active_driver.length;j++){
                        driversData.push(vehicleDetails[i].active_driver[j]);
                    }
                }
                console.log('driversData before===', driversData)
                setDriversData(driversData);
                setIsNearbyDrivers(true);
            }

            else if(response.flag==113){
                setDriversData([]);
                setNoServiceAvailable(true);
                if (isMerchantMode) {
                    setMessage(response.message || 'No service available for this route');
                    showSnackbar(true);
                }
            }
            else {
                // console.log('res.message', response.message);
                setDriversData([]);
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        if (isMerchantMode) return; 
        if(dropLatLng && polyLine )
        findNearbyDrivers();
    },[dropLatLng, polyLine, pickupLatLng]);

    const handleCloseSnackbar = () => {
        console.log('close')
        showSnackbar(false);
    };

    const searchDriverByPhone = async() =>{
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            const url = serverUrl + "/customer/user_by_phone_no"
            const obj={
                token: token, 
                timestamp: timestamp,
                // phone_number: phone,
                // client_id: localStorage.getItem('clientId')
            }
            if(corporateId && corporateId !== '0' && corporateId !== 'undefined' && corporateId !== 'null'){
                obj['corporate_id'] = corporateId;
            }
            if(searchByClient){
                obj['user_code'] = userCodeSearch;
            }else{
                obj['phone_number'] = phone;
            }
            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 200){
                setMessage(response.message)
                showSnackbar(true);
                const userbyPhone = response.data.user_details;
                setUserByPhone(userbyPhone);
                setSelectedUserId(userbyPhone.user_id);
                
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const fetchUserByPhone = async (phone) => {
        const token = localStorage.getItem('token');
        const url = serverUrl + "/customer/user_by_phone_no";
        const obj = {
            token: token,
            timestamp: new Date().getTime(),
            phone_number: phone,
        };
        if (corporateId && corporateId !== '0' && corporateId !== 'undefined' && corporateId !== 'null') {
            obj['corporate_id'] = corporateId;
        }
    
        const response = await makeGetRequestToUrl(url, obj);
    
        if (response.flag == 102) {
            localStorage.removeItem('token');
            setErrorMessage('Your session has expired. Please log in again.');
            setTokenExpired(true);
            setTimeout(() => navigate('/signup'), 2000);
            return null;
        }
    
        if (response.flag === 200 && response.data?.user_details) {
            const u = response.data.user_details;
            return {
                user_id: u.user_id,
                user_name: u.user_name,
                flat_no: u.flat_no || u.flat_number || '',   // <- use your actual field name
            };
        }
    
        // Not found or any other flag: the form shows "No user found" and switches to manual entry
        return null;
    };

    const searchByPhone = () =>{
        // console.log('phone = ', phone);
        // Change the map container style when Fetch Details is clicked
        setContainerStyle({
            width: '100%',
            height: '450px',  // Reduce the height when user details are fetched
        });
        setStopIds([]);
        searchDriverByPhone();
    }

    const fetchDataByVehicleType = async() => {
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/customer/find_nearby_drivers`;
            const body={
                token: token, 
                // timestamp: timestamp, 
                is_panel_request:1, 
                ride_distance: rideDistance/1000,
                ride_eta: rideEta,
                pickup_latitude: String(pickupLatLng.lat),
                pickup_longitude: String(pickupLatLng.lng),
                drop_latitude: String(dropLatLng.lat),
                drop_longitude: String(dropLatLng.lng),
                encoded_polyline: String(polyLine),
                city_id: cityFilter
            }
            if (isMerchantMode) {
                if (!merchantForm) return;
                Object.assign(body, { is_parcel: 1 }, buildParcelBody(merchantForm));
            }

            const response =  await makePostRequestToUrl(url, body);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 200){
                const vehicleDetails = response.data.vehicle_details;
                const driversData = [];
                setVehicleDetails(vehicleDetails);
                setCorporateFarePerRide(vehicleDetails[0].estimated_fare);
                for(var i=0;i<vehicleDetails.length;i++){
                    if(vehicleDetails[i].vehicle_id == vehicleId){
                        for(var j=0;j<vehicleDetails[i].active_driver.length;j++){
                            driversData.push(vehicleDetails[i].active_driver[j]);
                        }
                        setEstimatedFare(vehicleDetails[i].estimated_fare);
                    }
                }
                //console.log(driversData)
                setDriversData(driversData);
                setIsNearbyDrivers(true);
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    useEffect(()=>{
        //console.log('vehicleType', vehicleType, 'vehicleId=', vehicleId)
        if(vehicleType!='' || vehicleId!=''){
            fetchDataByVehicleType();
        }
        
    }, [vehicleType, vehicleId]);

    const autoAssignRide = async() =>{
        const token = localStorage.getItem('token');
        const timestamp = new Date().getTime();
        console.log('stop_ids= ', stopIds)
        const url = autosUrl + "/customer/request_ride"

        let filteredStops=[];
        if(stops.length && stops[0]?.address!=''){
            filteredStops = stops.filter(stop => stop?.address && stop?.address.trim() !== '');
        }
        if(stopIds.length && stopIds[0]?.locationId!=''){
            filteredStops = stopIds
            .filter(stop => stop.locationId && stop.locationId !== '')
            .map(stop => {
            const matchingLocation = pickupDropLocationData.find(loc => loc.id === stop?.locationId);

            if (matchingLocation && matchingLocation?.address !== '') {
                return {
                address: matchingLocation?.address_name,
                latitude: matchingLocation.latitude ?? stop.latitude,
                longitude: matchingLocation.longitude ?? stop.longitude,
                stop_id: stop.stop_id
                };
            }

            return null; // explicitly return null for unmatched
            })
            .filter(Boolean); 
        }
        let userIdsArr = [];
        if(additionalUserIds.length){
            userIdsArr = additionalUserIds.map(user => user.user_id);
        }
        const params={
            user_id: userByPhone.user_id,
            timestamp: timestamp,
            pickup_latitude: pickupLatLng ? pickupLatLng.lat : '',
            pickup_longitude: pickupLatLng ? pickupLatLng.lng : '',
            drop_latitude: dropLatLng ? dropLatLng.lat : '',
            drop_longitude: dropLatLng ? dropLatLng.lng : '',
            ride_distance: rideDistance/1000,
            ride_eta: rideEta,
            vehicle_id: vehicleId,
            // pickup_address: pickupAddress,
            // drop_address: dropAddress,
            waypoints: filteredStops,
            estimated_fare: estimatedFare,
        }
        if(adminid){
            params.admin_id = Number(adminid);
        }
        if(hasCorporate){
            params.corporate_id = Number(corporateId);
            params.payment_mode = 11;
        }

        if(normalAssign && assignGridData.length > 0){
            params['driver_array'] = assignGridData.map(marker => marker.driver_id);
        }
        if(selectedFareObj){
            params['fare_obj'] = selectedFareObj;
        }
        if(panel_customer_specific_address==1){
            const pickup_name = pickupLocationData.find(loc => loc.id === pickupLocation)?.address_name;
            const drop_name = dropLocationData.find(loc => loc.id === dropLocation)?.address_name;
            params['pickup_address'] = pickup_name;
            params['drop_address'] = drop_name;
        }
        else{
            params['pickup_address'] = pickupAddress;
            params['drop_address'] = dropAddress;
        }
        setAutoAssignParams(params);
    }

    useEffect(() => {
        if(normalAssign) autoAssignRide();
    }, [normalAssign ])

    const setAutoAsigningTrue = () =>{
        const params = autoAssignRide();
        setAutoAssigning(params);
        setFullScreenLoader(true);
        setNormalAssign(false);
        console.log('setting autoAssigning');
    }

    const handleModalSearchByClientToggle = (e) => {
        e.preventDefault();
        setModalUserCodeSearch('');
        setModalCustomerPhone('');
        setModalSearchByClient(!modalSearchByClient);
    }
    
    const setNormalAsigningTrue = (marker) =>{
        setAutoAssigning(true);
        setFullScreenLoader(true);
        setNormalAssign(true);
        setGridData((prevGridData) => [...prevGridData, marker]);
        setAssignGridData((prevAssignGridData) => [...prevAssignGridData, marker]);
    }

    const forceAssignRide = async() => {
        const token = localStorage.getItem('token');
        const timestamp = new Date().getTime();

        console.log('Current userStopMapping in scheduleBooking:', userStopMapping);
        
        // Create a mapping of user_code to user_id for lookup
        const userCodeToIdMap = {};
        additionalUserIds.forEach(user => {
            userCodeToIdMap[user.user_code] = user.user_id;
        });

        // Create the final mapping with user_ids
        const poolUserStopMapping = {};

        // Create a mapping of addresses to their stop_ids from modalWayPoints
        const addressToStopIdMap = {};
        modalWayPoints.forEach(waypoint => {
            if (waypoint.address && waypoint.stop_id) {
                addressToStopIdMap[waypoint.address] = waypoint.stop_id;
            }
        });

        const finalStopMapping = {};

        // First, process all users and their stops
        additionalUserIds.forEach(user => {
            // Check userStopMapping first (this will have the most recent values)
            const stopValue = userStopMapping[user.user_code] ?? 
                            userStopMapping[user.user_id] ?? 
                            user.user_stop;

            // Only process if we have a valid stop value
            if (stopValue !== undefined && stopValue !== null) {
                if (stopValue === 0 || stopValue==="0") {
                    // Pickup
                    finalStopMapping[user.user_id] = 0;
                } else if (stopValue === -1 || stopValue==="-1") {
                    // Drop
                    finalStopMapping[user.user_id] = -1;
                } else if (typeof stopValue === 'number' || !isNaN(parseInt(stopValue))) {
                    // Regular stop - ensure it's a number
                    const numValue = Number(stopValue);
                    if (numValue > 0) {
                        finalStopMapping[user.user_id] = numValue;
                    }
                }
            }
        });

        // Then process any remaining stops from userStopMapping that might not be in additionalUserIds
        Object.entries(userStopMapping).forEach(([key, value]) => {
            // Skip if we've already processed this user
            if (additionalUserIds.some(u => u.user_id === key || u.user_code === key)) {
                return;
            }

            // Check if the key is a user_id or user_code
            const userId = userCodeToIdMap[key] || key;
            
            // Only process if we have a valid stop value
            if (value === 0 || value === -1 || (typeof value === 'number' && value > 0)) {
                finalStopMapping[userId] = value;
            }
        });

        // Update the final mapping with any address-based stops
        additionalUserIds.forEach(user => {
            if (user.user_stop && typeof user.user_stop === 'string') {
                const stopId = addressToStopIdMap[user.user_stop];
                if (stopId) {
                    finalStopMapping[user.user_id] = stopId;
                }
            }
        });

        
        let filteredStops=[];
        if(stops.length && stops[0]?.address!=''){
            filteredStops = stops.filter(stop => stop?.address && stop?.address.trim() !== '');
        }
        if(stopIds.length && stopIds[0]?.locationId!=''){
            filteredStops = stopIds
            .filter(stop => stop.locationId && stop.locationId !== '')
            .map(stop => {
                const matchingLocation = pickupDropLocationData.find(loc => loc.id === stop?.locationId);
                // console.log('matchingLocation= ', matchingLocation)
                // console.log('pickupDropLocationData= ', pickupDropLocationData)
                return {
                    address: matchingLocation ? matchingLocation?.address_name : '', // fallback to empty string if not found
                    latitude: matchingLocation ? matchingLocation.latitude : stop.latitude,
                    longitude: matchingLocation ? matchingLocation.longitude : stop.longitude,
                    stop_id: stop.stop_id
                };
            });
        }
        if(modalWayPoints.length && modalWayPoints[0]?.address!=''){
            filteredStops = modalWayPoints.filter(stop => stop.address && stop.address.trim() !== '');
        }

        let userIdsArr = [];
        if(additionalUserIds.length){
            userIdsArr = additionalUserIds.map(user => user.user_id);
        }

        const payload={
            is_panel_request: 1,
            user_id: userByPhone.user_id,
            // timestamp: timestamp,
            pickup_latitude: pickupLatLng ? String(pickupLatLng.lat) : '',
            pickup_longitude: pickupLatLng ? String(pickupLatLng.lng) : '',
            drop_latitude: dropLatLng ? String(dropLatLng.lat) : '',
            drop_longitude: dropLatLng ? String(dropLatLng.lng) : '',
            ride_distance: rideDistance/1000,
            vehicle_id: vehicleId,
            // pickup_address: pickupAddress,
            // drop_address: dropAddress,
            estimated_fare: estimatedFare,
            driver_id: gridData.driver_id,
            waypoints: filteredStops,
            ride_eta: rideEta,
            driver_shift_id: gridData.shift_id,
            vehicle_make_id: gridData.shift_vehicle_id,
            admin_id: Number(adminid),
        }
        if(userIdsArr.length){
            payload['pool_users'] = userIdsArr;
        }
        if(selectedFareObj){
            payload['fare_obj'] = selectedFareObj;
        }
        if(panel_customer_specific_address==1){
            payload['pickup_address'] = pickupLocationData.find(loc => loc.id === pickupLocation)?.address_name;
            payload['drop_address'] = dropLocationData.find(loc => loc.id === dropLocation)?.address_name;
        }
        else{
            payload['pickup_address'] = pickupAddress;
            payload['drop_address'] = dropAddress;
        }

        if (Object.keys(finalStopMapping).length > 0) {
            payload['user_stop_mapping'] = finalStopMapping;
        }
        setForceAssignFlag(false);
        try {
            const url = autosUrl + "/customer/force_assign_ride"
            const response = await axios.post(url, payload);
            if (response.data.flag === 200) {
                setShowForceAssignedSuccess(true);
                setForceAssignData(response.data.data);
                setOngoingRideCheck(false);
                // setMessage(response.message)
                // showSnackbar(true);

            } else if (response.data.flag === 111) {
                // setShowForceAssignedSuccess(true);
                // setForceAssignData(response.data.data);

                setOngoingRideCheck(true);
                setOngoingRideCheckMessage(response.data.message);
                // setMessage(response.message)
                // showSnackbar(true);

            } else if (response.data.flag === 116) {
                setOngoingRideCheck(true);
                setOngoingRideCheckMessage(response.data.message);
                // setMessage(response.message)
                // showSnackbar(true);

            } else {
                console.error('Failed to assign', response.message);
                setOngoingRideCheck(false);
                // setMessage(response.message)
                // showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            // setMessage(error);
        }
    }

    const handleCloseModal = () => {
        setShowForceAssignedSuccess(false);
        window.location.reload();
    }

    const setSelectedDriverGridData = (marker) => {
        setForceAssignFlag(true);
        setGridData(marker);
        // if(gridData!='') forceAssignRide();
    }
    
    useEffect(()=>{
        if(gridData!='' && forceAssignFlag){
            forceAssignRide();
        }
    }, [gridData, forceAssignFlag])

    const handleChange = (vehicleId) => {
        const selectedVehicle = vehicleDetails.find(v => v.vehicle_id === vehicleId);  // Find the selected vehicle based on vehicle_id
        if (selectedVehicle) {
            setVehicleType(selectedVehicle.vehicle_type);  // Set vehicle_type state
            setVehicleId(vehicleId);  // Set vehicle_id state
            setSelectedFareObj(selectedVehicle.fare_obj);
        }else{
            setSelectedFareObj(null);
        }
    };

    const fetchAddress = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/customer/fetch_specific_address';
            const timestamp = new Date().getTime();
            const body1 = {
                token: token,
                user_id: userByPhone.user_id,
                address_type: 1,
                timestamp: timestamp
            };
            const body2 = {
                token: token,
                user_id: userByPhone.user_id,
                address_type: 2,
                timestamp: timestamp
            }
            const response =  await makeGetRequestToUrl(url, body1);
            const response2 = await makeGetRequestToUrl(url, body2);
            const both=[];
            if(response.flag==200){
                setPickupLocationData(response.data);
                both.push(...response.data);
            }
            if(response2.flag==200){
                setDropLocationData(response2.data);
                both.push(...response2.data);
            }
            console.log('both', both);
            setPickupDropLocationData(both);
            if(response.flag==102 || response2.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
    const handleCancelAutoAssignModal = async() => {
        setFullScreenLoader(true);
        const token = localStorage.getItem('token');
        
        // Get request_id from localStorage where it's stored during the streaming API response
        const storedRequestId = localStorage.getItem('current_request_id');
        console.log('Cancellation - Retrieved request_id:', storedRequestId);
        
        if (!storedRequestId) {
            console.error('No request_id available for cancellation');
            setMessage('Cannot cancel ride: No active request ID found');
            showSnackbar(true);
            setFullScreenLoader(false);
            return;
        }
        
        const payload = {
            token: token,
            trip_request_id: parseInt(storedRequestId, 10),
            user_id: userByPhone.user_id
        };
        
        console.log('Sending cancellation with payload:', payload);
        
        try {
            const url = operationsUrl + '/panel/cancel_ride';
            const response = await makePostRequestToUrl(url, payload);
            
            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                // Clear the stored request ID after successful cancellation
                localStorage.removeItem('current_request_id');
                window.location.reload();
            } else {
                setMessage(response.message || 'Cancellation request failed');
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error during cancellation:', error);
            setMessage(typeof error === 'string' ? error : 'An error occurred during cancellation');
            showSnackbar(true);
        }
        
        setFullScreenLoader(false);
    }

    const handleCloseOngoingRideCheckModal = () => {
        setOngoingRideCheck(false);
        // window.location.reload();
    };

    const handleAddStopIds = () => {
        if (stopIds.length >= 3) {
            setMessage('Maximum 3 stops are allowed');
            showSnackbar(true);
            return;
        }
        // Do not allow adding if previous stop does not have a selected address (empty locationId)
        if (stopIds.length > 0) {
            const lastStop = stopIds[stopIds.length - 1];
            if (!lastStop?.locationId) {
                setMessage('Please select the previous stop address before adding a new stop');
                showSnackbar(true);
                return;
            }
        }
        
        setStopIds(prevStopIds => {
            const newStop = {
                address: '',
                latitude: '',
                longitude: '',
                stop_id: prevStopIds.length + 1,
                locationId: ''
            };
            return reindexStopIds([...prevStopIds, newStop]);
        });
    };

    const handleRemoveStopIds = (index) => {
        setStopIds(prevStopIds => {
            const newStops = [...prevStopIds];
            newStops.splice(index, 1);
            return reindexStopIds(newStops);
        });
        // Reset vehicle selection as route changes
        setVehicleId('');
        setVehicleType('');
    };
    
    const handleOpenAddClientModal = () => {
        setModalPickupDropLocData([]);
        setFlagFetchingStops(false);
        if(Boolean(seatCount) && additionalUserIds.length >= Number(seatCount)){
            setAddClientModal(false);
            showSnackbar(true);
            setMessage('You can only add upto ' + seatCount + ' passengers.');
        }
        else{
            setAddClientModal(true);
        }
    };

    const handleCloseAddClientModal = () => {
        setAddClientModal(false);
        setModalCustomerPhone('');
        setModalUserCodeSearch('');
        setModalUSerId('');
        setModalUserName('');
        setModalPickupDropLocData([]);
        setFlagFetchingStops(false);  // Reset the flag when modal is closed
    };
    
    
    const fetchUserWalletBalance = async (userId) => {
        setEligibilityLoading(true);
        setUserRemainingTrips('');
        setUserRemainingBalance('');
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            const url = serverUrl + "/panel/check_corporate_eligibility";
            const response = await makeGetRequestToUrl(url, { token, timestamp, user_id: userId });
            if (response.flag === 200) {
                setUserRemainingTrips(response.data.remaining_trips);
                setUserRemainingBalance(response.data.remaining_balance);
            } else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setEligibilityLoading(false);
        }
        };
    
        useEffect(()=>{
            if(corporateFarePerRide && Boolean(selectedUserId) && hasCorporate){
                fetchUserWalletBalance(selectedUserId);
            }
        }, [corporateFarePerRide, selectedUserId]);
    
    
    const removeAddedClient = (id) => {
        // Find the user being removed to get their stop address
        const userToRemove = additionalUserIds.find(user => user.user_id === id);
        
        // Remove the user from additionalUserIds
        const updatedUserIds = additionalUserIds.filter(x => x.user_id !== id);
        setAdditionalUserIds(updatedUserIds);
        
        // If user has a stop, update the modalWayPoints
        if (userToRemove?.user_stop) {
            // Remove the waypoint and update stop_id sequence
            setModalWayPoints(prev => {
                // Filter out the waypoint being removed and any with empty addresses
                const updatedWaypoints = prev.filter(waypoint => 
                    waypoint.address !== userToRemove.user_stop && 
                    waypoint.address && 
                    waypoint.address.trim() !== ''
                );
                
                // Reassign stop_id in sequential order
                return updatedWaypoints.map((waypoint, index) => ({
                    ...waypoint,
                    stop_id: index + 1
                }));
            });
        }
    };

    const searchAddClient = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            const url = serverUrl + "/customer/user_by_phone_no";
            const obj = { token, timestamp };

            if (modalSearchByClient) {
                if (!modalUserCodeSearch) {
                    setMessage('Please enter Client ID');
                    showSnackbar(true);
                    return;
                }
                obj['user_code'] = modalUserCodeSearch;
            } else {
                if (!modalCustomerPhone) {
                    setMessage('Please enter phone number');
                    showSnackbar(true);
                    return;
                }
                obj['phone_number'] = modalCustomerPhone;
            }

            const response = await makeGetRequestToUrl(url, obj);

            if (response.flag == 102) {
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => navigate('/signup'), 2000);
                return;
            }

            if (response.flag === 200) {
                setFlagFetchingStops(true);
                const details = response.data.user_details;
                const newId = details?.user_id;
                const newName = details?.user_name;

                setModalUSerId(newId);
                setModalUserName(newName);

                if (!newId) {
                    setMessage('User not found');
                    showSnackbar(true);
                    return;
                }
             const isUserAlreadyAdded = additionalUserIds.some(u => 
                u.user_id === newId || 
                (modalCustomerPhone && u.phone_number === modalCustomerPhone)
                );

            if (isUserAlreadyAdded) {
                // If user is already added, update the modal fields to show their existing selection
                const existingUser = additionalUserIds.find(u => 
                    u.user_id === newId || 
                    (modalCustomerPhone && u.phone_number === modalCustomerPhone)
                );
                
                if (existingUser) {
                    setModalUSerId(existingUser.user_id);
                    setModalUserName(existingUser.user_name);
                    setModalUserCodeSearch(existingUser.user_code || '');
                    
                    // If the existing user has a stop mapping, update the UI to show it
                    if (existingUser.user_stop !== undefined) {
                        // Preserve the existing stop mapping
                        setUserStopMapping(prev => ({
                            ...prev,
                            [existingUser.user_code || existingUser.user_id]: existingUser.user_stop
                        }));
                        
                        // Don't clear the modal fields here to show the existing stop
                        setMessage('This user is already added to the booking');
                        showSnackbar(true);
                        return;
                    }
                }
                
                // Only clear if we didn't find an existing user with a stop
                setModalCustomerPhone('');
                setModalUserCodeSearch('');
                setMessage('This user is already added to the booking');
                showSnackbar(true);
                return;
            }
                if (userByPhone?.user_id && newId === userByPhone.user_id) {
                    setMessage('Primary client is already selected');
                    showSnackbar(true);
                    return;
                }
                if (additionalUserIds.some(u => u.user_id === newId)) {
                    setMessage('Client already added');
                    showSnackbar(true);
                    return;
                }
                if (seatCount && additionalUserIds.length >= Number(seatCount)) {
                    setMessage(`You can add up to ${seatCount} clients`);
                    showSnackbar(true);
                    return;
                }
            } else {
                setMessage(response.message);
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if(vehicleType){
            setAdditionalUserIds([]);
            setModalWayPoints([]);
        }
    }, [vehicleType]);

    const addingClient = async() => {
        if(!flagFetchingStops){
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();
                const url = serverUrl + "/customer/user_by_phone_no";
                const obj = { token, timestamp };

                if (modalSearchByClient) {
                    if (!modalUserCodeSearch) {
                        setMessage('Please enter Client ID');
                        showSnackbar(true);
                        return;
                    }
                    obj['user_code'] = modalUserCodeSearch;
                } else {
                    if (!modalCustomerPhone) {
                        setMessage('Please enter phone number');
                        showSnackbar(true);
                        return;
                    }
                    obj['phone_number'] = modalCustomerPhone;
                }

                const response = await makeGetRequestToUrl(url, obj);

                if (response.flag === 200) {
                    const details = response.data.user_details;
                    const newId = details?.user_id;
                    const newName = details?.user_name;
                    // fetchAddress(newId);
                    setModalUSerId(newId);
                    setModalUserName(newName);

                    if (!newId) {
                        setMessage('User not found');
                        showSnackbar(true);
                        return;
                    }
                    if (userByPhone?.user_id && newId === userByPhone.user_id) {
                        setMessage('Primary client is already selected');
                        showSnackbar(true);
                        return;
                    }
                    if (additionalUserIds.some(u => u.user_id === newId)) {
                        setMessage('Client already added');
                        showSnackbar(true);
                        return;
                    }
                    if (seatCount && additionalUserIds.length >= Number(seatCount)) {
                        setMessage(`You can add up to ${seatCount} clients`);
                        showSnackbar(true);
                        return;
                    }

                    setAdditionalUserIds(prev => {
                        // Check if user already exists (by ID or phone)
                        const existingUserIndex = prev.findIndex(u => 
                            u.user_id === newId || 
                            (modalCustomerPhone && u.phone_number === modalCustomerPhone)
                        );

                        if (existingUserIndex !== -1) {
                            // Update existing user
                            const updated = [...prev];
                            updated[existingUserIndex] = {
                                ...updated[existingUserIndex],
                                user_name: newName,
                                user_code: modalUserCodeSearch,
                                ...(selectedStop !== undefined && { user_stop: address })
                            };
                            return updated;
                        } else {
                            // Add new user
                            return [...prev, { 
                                user_id: newId, 
                                user_name: newName,
                                user_code: modalUserCodeSearch,
                                ...(modalCustomerPhone && { phone_number: modalCustomerPhone }),
                                ...(selectedStop !== undefined && { user_stop: address })
                            }];
                        }
                    });
                    
                } else {
                    setMessage(response.message);
                    showSnackbar(true);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        else{

            setAdditionalUserIds(prev => {
                // Check if user already exists (by ID or phone)
                const existingUserIndex = prev.findIndex(u => 
                    u.user_id === modalUSerId || 
                    (modalCustomerPhone && u.phone_number === modalCustomerPhone)
                );

                if (existingUserIndex !== -1) {
                    // Update existing user
                    const updated = [...prev];
                    updated[existingUserIndex] = {
                        ...updated[existingUserIndex],
                        user_name: modalUserName,
                        user_code: modalUserCodeSearch,
                        ...(selectedStop !== undefined && { user_stop: address })
                    };
                    return updated;
                } else {
                    // Add new user
                    return [...prev, { 
                        user_id: modalUSerId, 
                        user_name: modalUserName,
                        user_code: modalUserCodeSearch,
                        ...(modalCustomerPhone && { phone_number: modalCustomerPhone }),
                        ...(selectedStop !== undefined && { user_stop: address })
                    }];
                }
            });
        }
        
        const selectedStop = userStopMapping[modalUserCodeSearch];
        const matchingAddress = modalPickupDropLocData.find(stop => stop.id === selectedStop);

        const address = matchingAddress ? matchingAddress.address_name : '';

        setModalWayPoints(prev => {
            // Only add the new waypoint if address is not empty
            if (address && address.trim() !== '') {
                return [
                    ...prev.filter(waypoint => 
                        waypoint.address && waypoint.address.trim() !== ''
                    ),
                    {
                        address: address,
                        latitude: matchingAddress ? matchingAddress.latitude : '',
                        longitude: matchingAddress ? matchingAddress.longitude : '',
                        stop_id: prev.filter(waypoint => 
                            waypoint.address && waypoint.address.trim() !== ''
                        ).length + 1
                    }
                ];
            }
            return prev;
        });

        setMessage('Client added');
        showSnackbar(true);
        setModalCustomerPhone('');
        setModalUserCodeSearch('');
        setModalUSerId('');
        setModalUserName('');
        setModalPickupDropLocData([]);
        setFlagFetchingStops(false);
    }

    const toText = (m) => {
        if (!m) return 'Could not create order';
        if (typeof m === 'string') return m;
        if (Array.isArray(m?.details)) return m.details.map(d => d.message).join(', ');
        if (m?.message) return String(m.message);
        try { return JSON.stringify(m); } catch { return 'Could not create order'; }
    };

    const createParcelOrder = async (form) => {
        if (!pickupLatLng || !dropLatLng) {
            setMessage('Please select pickup and drop locations');
            showSnackbar(true);
            return;
        }
        setCreatingOrder(true);
        try {
            const contactOf = (c) => ({ name: c.name, phone_number: c.phone, flat_no: c.flat, user_id: c.userId });
    
            // helper: Joi.string()/number() reject '' and null, so drop empty values
            const clean = (o) => Object.fromEntries(
                Object.entries(o).filter(([, v]) => v !== '' && v !== null && v !== undefined)
            );

            const parcelFields = (p = {}) => clean({
                parcel_type_name: p.parcel_type_name,
                weight_unit: p.weight_unit,
                weight: p.weight,
                size_unit: p.size_unit,
                length: p.length,
                height: p.height,
                sender_instructions: p.instructions
            });

            const { sender, recipient } = form;

            const waypoints = form.stops
                .filter(s => s.latitude && s.longitude)
                .map((s, i) => ({
                    address: s.address,
                    latitude: s.latitude,
                    longitude: s.longitude,
                    stop_id: i + 1,
                }));

            const stop_parcel_details = form.stops
                .filter(s => s.latitude && s.longitude)
                .map((s, i) => clean({
                    stop_id: i + 1,
                    is_parcel: 1,
                    sender_name: sender.name,
                    sender_mobile: sender.phone,
                    sender_flat_house_no: sender.flat,
                    recipient_name: s.contact?.name,
                    recipient_mobile: s.contact?.phone,
                    recipient_flat_house_no: s.contact?.flat,
                    sender_instructions: sender.instructions,
                    ...parcelFields(s.parcel),
                }));

            const payload = clean({
                is_parcel: 1,
                is_panel_request: 1,
                user_id: sender.userId,
                admin_id: Number(adminid),
                merchant_id: Number(merchantIdFromLocal),
                // city_id: cityFilter,
                vehicle_id: vehicleId,
                pickup_latitude: String(pickupLatLng.lat),
                pickup_longitude: String(pickupLatLng.lng),
                drop_latitude: String(dropLatLng.lat),
                drop_longitude: String(dropLatLng.lng),
                pickup_address: pickupLocation || pickupAddress,
                drop_address: dropLocation || dropAddress,
                ride_distance: rideDistance / 1000,
                ride_eta: rideEta,
                estimated_fare: estimatedFare,
                waypoints,

                stop_parcel_details: stop_parcel_details.length ? stop_parcel_details : undefined,
                sender_name: sender.name,
                sender_mobile: sender.phone,
                sender_flat_house_no: sender.flat,
                recipient_name: recipient.name,
                recipient_mobile: recipient.phone,
                recipient_flat_house_no: recipient.flat,
                sender_instructions: sender.instructions,
                ...parcelFields(recipient.parcel),
                payment_mode: 1,
                payment_app: 'Cash',

            });
            if (selectedFareObj) payload.fare_obj = selectedFareObj;

            console.log('request_ride payload', JSON.stringify(payload, null, 2));

            // const response = await axios.post(autosUrl + '/customer/request_ride', payload);
    
            // if (response.status === 200 && response.data?.flag === 200) {
            //     setOrderCreated(response.data.data || {});
            // } else {
            //     setMessage(toText(response.data?.message || response.data?.error));
            //     showSnackbar(true);
            // }
            setMerchantUserId(sender.userId || null);
            setAutoAssignParams(payload);
            setNormalAssign(false);
            setAutoAssigning(true);
            setFullScreenLoader(true);
        } catch (err) {
            console.error('Create order failed:', err);
            const data = err?.response?.data;
            console.error('Create order failed:', data || err);
            setMessage(toText(data?.message || data?.error || data));
            showSnackbar(true);
        } finally {
            setCreatingOrder(false);
        }
    };

    const handleFindVehicles = async (form) => {
        if (!pickupLatLng || !dropLatLng || !polyLine) {
            setMessage('Please select pickup and drop locations');
            showSnackbar(true);
            return;
        }
        setMerchantForm(form);
        setFindingVehicles(true);
        try {
            await findNearbyDrivers(form);
        } finally {
            setFindingVehicles(false);
        }
    };
    
    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Grid2 container item spacing={2} sx={{display:'flex'}}>
                <Grid2 item size={4.5}>
                    <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Manual Dispatcher</Typography>
                    <Grid2 item sx={{display:'flex', marginTop:'2%'}}>
                        <Grid2 sx={{marginRight:'4%'}}>
                            <Select
                                value={cityFilter}
                                onChange={(e) => handleFilterChange('city', e.target.value)}
                                displayEmpty
                                style={{
                                    width: '200px',
                                    height: '46px',
                                    borderRadius: '8px',
                                    backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                                }}
                            >
                                <MenuItem value="">Select City</MenuItem>
                                {cities.map((city) => (
                                    <MenuItem key={city.city_id} value={city.city_id}>
                                        {city.city_name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid2>
                        {/* <Grid2>
                            <input type="number" placeholder="Search Driver" className='filterBtn' style={{width:'200px'}}/>
                        </Grid2> */}
                    </Grid2>


                    {merchantIdFromLocal != 0 ? 
                    (
                        <MerchantParcelForm
                            parcelTypes={parcelTypes}
                            pickupLocation={pickupLocation} setPickupLocation={setPickupLocation}
                            dropLocation={dropLocation} setDropLocation={setDropLocation}
                            stops={stops} setStops={setStops}
                            handleAddStop={handleAddStop} handleRemoveStop={handleRemoveStop}
                            handleStopLocationChange={handleStopLocationChange} handleStopFocus={handleStopFocus}
                            inputRef={inputRef} inputDropRef={inputDropRef} stopRefs={stopRefs}
                            pickupMarker={pickupMarker} dropMarker={dropMarker}
                            remove_add_stops={remove_add_stops} country_code={country_code}
                            fetchUserByPhone={fetchUserByPhone}
                            onChange={(data) => setMerchantParcelData(data)}
                            vehicleId={vehicleId}
                            vehicleDetails={vehicleDetails}
                            handleVehicleChange={handleChange}
                            cityFilter={cityFilter}
                            onCreate={createParcelOrder}
                            creating={creatingOrder}
                            onFindVehicles={handleFindVehicles}
                            finding={findingVehicles}
                            routeReady={!!polyLine && !!pickupLatLng && !!dropLatLng}
                            onInvalidate={resetVehicles}
                        />
                    )
                    :
                    <Grid2 container item sx={{ marginTop: '2%', maxHeight: '610px', overflowY: 'auto' }}>
                        {driversData && driversData.length > 0 ? (
                            driversData.map((marker) => (
                                <Grid2 item className="mainBox" sx={{ marginTop: '4%' }}>
                                    <Grid2 item container>
                                        <Grid2 item size={2}>
                                            <Avatar sx={{ borderColor: '#0065FF', border: 1 }} alt={marker.driver_image || altAvatar} src={marker.driver_image || altAvatar} />
                                        </Grid2>
                                        <Grid2 item size={7}>
                                            <Typography sx={{ fontSize: '16px', color: '#83888E' }}>{marker.driver_name}</Typography>
                                            <Typography>ID: {marker.driver_id} {marker.distance ? `( Estimated Distance : ${marker.distance} km )` : ''}</Typography>
                                        </Grid2>
                                        <Grid2 item size={3}>
                                            <Button
                                                variant="contained"
                                                sx={{
                                                    backgroundColor: marker.driver_status === 0 ? '#F9E9E9' : '#E7F8F2',
                                                    color: marker.driver_status === 0 ? '#D14545' : '#0DBA78',
                                                    textTransform: 'none',
                                                    pointerEvents: 'none',
                                                    borderRadius: '6px',
                                                    minWidth: '60px',
                                                    border: 'none',
                                                    boxShadow: 'none',
                                                    fontFamily: 'Poppins',
                                                    marginRight: '16px',
                                                }}
                                            >
                                                <FiberManualRecordIcon style={{ fontSize: '16px' }} /> {marker.driver_status === 0 ? 'Inactive' : 'Active'}
                                            </Button>
                                        </Grid2>
                                    </Grid2>

                                    <Box
                                        sx={{
                                            height: '1px',
                                            width: '100%',
                                            margin: '20px 0',
                                            background: 'linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))',
                                            borderTop: '2px dashed transparent',
                                            maskImage: 'linear-gradient(to right, black, transparent)',
                                            WebkitMaskImage: 'linear-gradient(to right, black, transparent)',
                                        }}
                                    />

                                    <Grid2 item container sx={{ marginTop: '2%' }}>
                                        <Grid2 item size={1.5} sx={{ marginTop: '1%' }}>
                                            {marker.vehicle_type === 1 && <Grid2><img src={vehicleTypeCar} alt="Ryde" /></Grid2>}
                                            {marker.vehicle_type === 2 && <Grid2><img src={vehicleTypeBike} alt="bike" /></Grid2>}
                                            {marker.vehicle_type === 3 && <Grid2><img src={vehicletypeAuto} alt="auto" /></Grid2>}
                                        </Grid2>
                                        <Grid2 item size={8}>
                                            <Typography sx={{ fontSize: '12px', color: '#83888E' }}>Economy</Typography>
                                            <Typography sx={{ color: '#4E545D', fontSize: '14px' }}>{marker.vehicle_no}</Typography>
                                        </Grid2>
                                        {(is_driver_debt_limit_enabled==1) &&
                                            <Grid2 item size={2}>                          
                                                {( marker?.driver_wallet_balance < debtLimit) && 
                                                    <Typography sx={{color:'#eb530daa', textAlign:'center'}}>(In debt)</Typography>
                                                }
                                            </Grid2>
                                        }
                                    </Grid2>

                                    {vehicleType && (!corporateId || corporateId === '0' || corporateId === 'undefined' || corporateId === 'null') && (
                                        <Grid2 item container sx={{ marginTop: '2%' }}>
                                            {((additionalUserIds.length <= 0 && add_pool_users) || !add_pool_users) && (
                                                <Grid2 item size={6}>
                                                    <Button
                                                        variant="contained"
                                                        sx={{ backgroundColor: '#F9F9F9', border: '1px solid #D1D5DB', width: '98%', boxShadow: 'none' }}
                                                        onClick={() => setNormalAsigningTrue(marker)}
                                                    >
                                                        <Typography sx={{ color: '#83888E', textTransform: 'none' }}>Assign</Typography>
                                                    </Button>
                                                </Grid2>
                                            )}
                                            <Grid2 item size={additionalUserIds.length > 0 ? 12 : 6}>
                                                <Button
                                                    variant="contained"
                                                    sx={{ backgroundColor: '#F3F8FF', border: '1px solid #0065FF', width: '98%', boxShadow: 'none' }}
                                                    onClick={() => setSelectedDriverGridData(marker)}
                                                >
                                                    <Typography sx={{ color: '#0065FF', textTransform: 'none' }}>Force Assign</Typography>
                                                </Button>
                                            </Grid2>
                                        </Grid2>
                                    )}
                                </Grid2>
                            ))
                        ) : noServiceAvailable ? (
                            <div style={styles.errorBox}>
                                <p>No service available in this location</p>
                            </div>
                        ) : (
                            <div style={styles.errorBox}>
                                <p>No driver is online at this time.</p>
                            </div>
                        )}
                    </Grid2>
                    }

                </Grid2>
                {/* <Grid2 item size={0.2}></Grid2> */}
                <Grid2 item size={7.5} className="mainBox" sx={{marginTop:'1%', maxHeight: '85vh', overflowY: 'auto', overflowX: 'hidden', padding: '10px'}}>

                {merchantIdFromLocal == 0 &&
                (
                    <>

                    <Grid2 item sx={{marginTop:'1%'}}>
                        <Typography sx={{color:'#000', fontWeight:'500', fontSize:'20px'}}>Enter User Details</Typography>
                    </Grid2>

                    {clientId==188 && 
                        <Grid2 item container sx={{alignItems:'center'}}>
                            <Typography sx={{color:'#83888E'}}>Search by phone number</Typography>
                            <Switch
                                checked={!searchByClient}
                                onChange={() => setSearchByClient(!searchByClient)}
                            />
                        </Grid2>
                    }

                    <Grid2 item size={12} sx={{marginTop:'1%', display:'flex'}}>
                        {!searchByClient && 
                            <Grid2 item size={6.5}>
                                <PhoneInput
                                    defaultCountry={country_code || "IN"}
                                    style={{
                                        // width: '380px',  // Set width
                                        height: '44px',  // Set height
                                        fontSize: '16px',
                                        alignItems:'normal'
                                    }}
                                    placeholder=" Enter phone number"
                                    value={phone}
                                    onChange={setPhone}
                                />
                            </Grid2>
                        }

                        {searchByClient && 
                            <Grid2 item size={6.5}>
                                <TextField
                                    label="Enter Client ID"
                                    value={userCodeSearch}
                                    onChange={(e) => setUserCodeSearch(e.target.value)}
                                    sx={{
                                        width: '100%',
                                        '& .MuiInputBase-root': {
                                            height: '44px',  // Reduced from default
                                            fontSize: '14px',
                                            alignItems: 'center'
                                        },
                                        '& .MuiInputLabel-root': {
                                            transform: 'translate(14px, 10px) scale(1)',  // Adjust label position
                                            '&.MuiInputLabel-shrink': {
                                                transform: 'translate(14px, -9px) scale(0.75)',  // Adjust shrunk label position
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: '8px 6px'
                                        },
                                    }}                                            
                                />
                            </Grid2>
                        }
                        <Grid2 item size={5.5} sx={{marginLeft:'3%'}}>
                            <Button sx={{textTransform:'none', borderRadius:'8px', width:'100%',
                            color:'#0065FF', height: '44px', border:'1px solid #0065FF'}} onClick={searchByPhone}>
                                Fetch Details
                            </Button>
                        </Grid2>
                    </Grid2>


                    {(panel_customer_specific_address==1 && userByPhone) && (
                        <>
                            <Typography sx={{color: '#83888E', fontSize:'16px', marginTop:'1%'}}>Enter Locations</Typography>
                            <Grid2 container spacing={2}>
                                <Grid2 item size={remove_add_stops == 1 ? 6 : 5}>
                                    <Select
                                        sx={{
                                            marginTop: '1%',
                                            height: '50px',
                                            borderRadius:'12px',
                                            backgroundColor: '#FFFFFF',
                                            '& .MuiSelect-select': {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }
                                        }} fullWidth
                                        value={pickupLocation}
                                        onChange={(e) => {
                                            const nextPickupId = e.target.value;
                                            setVehicleId('');
                                            setVehicleType('');
                                            // Validate against first stop BEFORE committing state
                                            const selectedLocation = pickupLocationData.find(location => location.id === nextPickupId);
                                            if (selectedLocation) {
                                                const lat = parseFloat(selectedLocation.latitude);
                                                const lng = parseFloat(selectedLocation.longitude);
                                                if (!isNaN(lat) && !isNaN(lng)) {
                                                    // If there are no stops and pickup-drop < 100m, clear drop instead of blocking
                                                    try {
                                                        const hasStopIds = Array.isArray(stopIds) && stopIds.length > 0 && stopIds.some(s => s?.locationId || (s.latitude && s.longitude));
                                                        const hasManualStops = Array.isArray(stops) && stops.some(s => s.latitude && s.longitude);
                                                        const noStops = !hasStopIds && !hasManualStops;
                                                        if (noStops && dropLatLng && window.google && window.google.maps && window.google.maps.geometry) {
                                                            const distPD = window.google.maps.geometry.spherical.computeDistanceBetween(
                                                                new window.google.maps.LatLng(lat, lng),
                                                                new window.google.maps.LatLng(dropLatLng.lat, dropLatLng.lng)
                                                            );
                                                            if (distPD < 100) {
                                                                // Clear drop since it's too close to the chosen pickup and no stops exist
                                                                setDropLocation('');
                                                                setDropLatLng(null);
                                                            }
                                                        }
                                                    } catch (_) { /* ignore */ }
                                                    // Determine first stop (prefer stopIds, else manual stops)
                                                    let firstStop = null;
                                                    let firstStopId = 1;
                                                    if (stopIds && stopIds.length > 0 && (stopIds[0]?.locationId || (stopIds[0].latitude && stopIds[0].longitude))) {
                                                        firstStopId = stopIds[0].stop_id || 1;
                                                        const s = stopIds[0];
                                                        if (s.latitude && s.longitude) {
                                                            firstStop = { lat: parseFloat(s.latitude), lng: parseFloat(s.longitude) };
                                                        } else if (s?.locationId) {
                                                            const m = pickupDropLocationData.find(loc => loc.id === s?.locationId);
                                                            if (m && m.latitude && m.longitude) {
                                                                firstStop = { lat: parseFloat(m.latitude), lng: parseFloat(m.longitude) };
                                                            }
                                                        }
                                                    } else if (stops && stops.length > 0 && stops[0].latitude && stops[0].longitude) {
                                                        firstStopId = stops[0].stop_id || 1;
                                                        firstStop = { lat: parseFloat(stops[0].latitude), lng: parseFloat(stops[0].longitude) };
                                                    }

                                                    if (firstStop && window.google && window.google.maps && window.google.maps.geometry) {
                                                        const dist = window.google.maps.geometry.spherical.computeDistanceBetween(
                                                            new window.google.maps.LatLng(lat, lng),
                                                            new window.google.maps.LatLng(firstStop.lat, firstStop.lng)
                                                        );
                                                        if (dist < 100) {
                                                            setMessage(`Distance is within 100m. First remove the stop with stop ID ${firstStopId}`);
                                                            showSnackbar(true);
                                                            return; // Block selecting this pickup
                                                        }
                                                    }

                                                    // Passed validation: commit state
                                                    setPickupLocation(nextPickupId);
                                                    setPickupLatLng({lat, lng});
                                                } else {
                                                    console.error('Invalid pickup coordinates:', selectedLocation);
                                                }
                                            }
                                        }}
                                        displayEmpty
                                        renderValue={(selected) => (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <img src={pickupMarker} alt="pickup marker" width="20" height="20" />
                                                {selected ? pickupLocationData.find(loc => loc.id === selected)?.address_name : 
                                                    <Typography sx={{ color: '#666' }}>Select Pickup Address</Typography>}
                                            </Box>
                                        )}
                                        
                                    >
                                        <MenuItem value="" disabled>
                                            <Typography sx={{ color: '#666' }}>Select Pickup Address</Typography>
                                        </MenuItem>
                                        {pickupLocationData.map((location) => (
                                            <MenuItem key={location.id} value={location.id}>
                                                {location.address_name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid2>

                                <Grid2 item size={remove_add_stops == 1 ? 6 : 5}>
                                    <Select
                                        sx={{
                                            marginTop: '1%',
                                            height: '50px',
                                            borderRadius:'12px',
                                            backgroundColor: '#FFFFFF',
                                            '& .MuiSelect-select': {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }
                                        }} fullWidth
                                        value={dropLocation}
                                        onChange={(e) => {
                                            const nextDropId = e.target.value;
                                            setVehicleId('');
                                            setVehicleType('');
                                            // Validate against last stop BEFORE committing state
                                            const selectedLocation = dropLocationData.find(location => location.id === nextDropId);
                                            if (selectedLocation) {
                                                const lat = parseFloat(selectedLocation.latitude);
                                                const lng = parseFloat(selectedLocation.longitude);
                                                if (!isNaN(lat) && !isNaN(lng)) {
                                                    // If there are no stops at all, enforce pickup vs drop >= 100m
                                                    try {
                                                        const hasStopIds = Array.isArray(stopIds) && stopIds.length > 0 && stopIds.some(s => s?.locationId || (s.latitude && s.longitude));
                                                        const hasManualStops = Array.isArray(stops) && stops.some(s => s.latitude && s.longitude);
                                                        const noStops = !hasStopIds && !hasManualStops;
                                                        if (noStops && pickupLatLng && window.google && window.google.maps && window.google.maps.geometry) {
                                                            const distPD = window.google.maps.geometry.spherical.computeDistanceBetween(
                                                                new window.google.maps.LatLng(pickupLatLng.lat, pickupLatLng.lng),
                                                                new window.google.maps.LatLng(lat, lng)
                                                            );
                                                            if (distPD < 100) {
                                                                setMessage('Pickup and drop must be at least 100m apart');
                                                                showSnackbar(true);
                                                                return; // Block selecting this drop
                                                            }
                                                        }
                                                    } catch (_) { /* ignore advisory errors */ }
                                                    // Determine last stop (prefer stopIds, else manual stops)
                                                    let lastStop = null;
                                                    let lastStopId = null;
                                                    if (stopIds && stopIds.length > 0 && (stopIds[stopIds.length - 1]?.locationId || (stopIds[stopIds.length - 1].latitude && stopIds[stopIds.length - 1].longitude))) {
                                                        const s = stopIds[stopIds.length - 1];
                                                        lastStopId = s.stop_id || stopIds.length;
                                                        if (s.latitude && s.longitude) {
                                                            lastStop = { lat: parseFloat(s.latitude), lng: parseFloat(s.longitude) };
                                                        } else if (s?.locationId) {
                                                            const m = pickupDropLocationData.find(loc => loc.id === s?.locationId);
                                                            if (m && m.latitude && m.longitude) {
                                                                lastStop = { lat: parseFloat(m.latitude), lng: parseFloat(m.longitude) };
                                                            }
                                                        }
                                                    } else if (stops && stops.length > 0 && stops[stops.length - 1].latitude && stops[stops.length - 1].longitude) {
                                                        const s = stops[stops.length - 1];
                                                        lastStopId = s.stop_id || stops.length;
                                                        lastStop = { lat: parseFloat(s.latitude), lng: parseFloat(s.longitude) };
                                                    }

                                                    if (lastStop && window.google && window.google.maps && window.google.maps.geometry) {
                                                        const dist = window.google.maps.geometry.spherical.computeDistanceBetween(
                                                            new window.google.maps.LatLng(lat, lng),
                                                            new window.google.maps.LatLng(lastStop.lat, lastStop.lng)
                                                        );
                                                        if (dist < 100) {
                                                            setMessage(`Distance is within 100m. First remove the stop with stop ID ${lastStopId}`);
                                                            showSnackbar(true);
                                                            return; // Block selecting this drop
                                                        }
                                                    }

                                                    // Passed validation: commit state
                                                    setDropLocation(nextDropId);
                                                    setDropLatLng({lat, lng});
                                                } else {
                                                    console.error('Invalid drop coordinates:', selectedLocation);
                                                }
                                            }
                                        }}
                                        displayEmpty
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <img src={dropMarker} alt="drop marker" />
                                            </InputAdornment>
                                        }
                                    >
                                        <MenuItem value="" disabled>
                                            <Typography sx={{ color: '#666' }}>Select Drop Address</Typography>
                                        </MenuItem>
                                        {dropLocationData.map((location) => (
                                            <MenuItem key={location.id} value={location.id}>
                                                {location.address_name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid2>
                                
                                {(remove_add_stops!=1) &&
                                <Grid2 item size={2}
                                    sx={{
                                        border:'1px solid #0065ff', 
                                        borderRadius:'12px',
                                        display:'flex', 
                                        alignItems:'center', 
                                        justifyContent:'center', 
                                        cursor:'pointer',
                                        '&:hover': { backgroundColor: '#f0f7ff' }
                                    }}
                                    onClick={handleAddStopIds}
                                >
                                    <Typography sx={{color:'#0065ff', textAlign:'center'}}>Add Stop</Typography>
                                </Grid2>
                                }
                            </Grid2>

                            {stopIds.map((stop, index) => (
                                <Grid2 container key={`stop-${stop.stop_id}`} sx={{marginTop:'1%'}}>
                                    <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                        <span style={{
                                            display: 'inline-block',
                                            minWidth: 24,
                                            minHeight: 24,
                                            borderRadius: '50%',
                                            background: '#0065ff',
                                            color: '#fff',
                                            fontWeight: 500,
                                            textAlign: 'center',
                                            lineHeight: '24px',
                                            marginRight: 8
                                        }}>{stop.stop_id || index + 1}</span>

                                        <Select
                                            sx={{
                                                marginTop: '1%', height: '50px', borderRadius:'12px', backgroundColor: '#FFFFFF', width:'600px',
                                                '& .MuiSelect-select': {
                                                    display: 'flex', alignItems: 'center', gap: '8px'
                                                }
                                            }} fullWidth value={stop?.locationId || ''}
                                            onChange={(e) => {
                                                const selectedLocation = pickupDropLocationData.find(location => location.id === e.target.value);
                                                if (selectedLocation) {
                                                    // Compute distance from previous point (pickup or previous stop)
                                                    const lat = parseFloat(selectedLocation.latitude);
                                                    const lng = parseFloat(selectedLocation.longitude);
                                                    if (!isNaN(lat) && !isNaN(lng)) {
                                                        let prevPoint = null;
                                                        if (index === 0) {
                                                            // Previous is pickup location for first stop
                                                            if (pickupLatLng && pickupLatLng.lat && pickupLatLng.lng) {
                                                                prevPoint = { lat: pickupLatLng.lat, lng: pickupLatLng.lng };
                                                            }
                                                        } else {
                                                            const prevStop = stopIds[index - 1];
                                                            if (prevStop && prevStop.latitude && prevStop.longitude) {
                                                                prevPoint = { lat: parseFloat(prevStop.latitude), lng: parseFloat(prevStop.longitude) };
                                                            }
                                                        }

                                                        if (prevPoint && window.google && window.google.maps && window.google.maps.geometry) {
                                                            const dist = window.google.maps.geometry.spherical.computeDistanceBetween(
                                                                new window.google.maps.LatLng(prevPoint.lat, prevPoint.lng),
                                                                new window.google.maps.LatLng(lat, lng)
                                                            );
                                                            if (dist < 100) {
                                                                setMessage('Selected stop is too close to the previous location (< 100m)');
                                                                showSnackbar(true);
                                                                return; // Block selection
                                                            }
                                                        }

                                                        // Validate against the next point as well: use next stop if exists,
                                                        // otherwise (for the last stop) use the drop location when available
                                                        {
                                                            let nextPoint = null;
                                                            if (index < stopIds.length - 1) {
                                                                const nextStop = stopIds[index + 1];
                                                                if (nextStop) {
                                                                    if (nextStop.latitude && nextStop.longitude) {
                                                                        nextPoint = { lat: parseFloat(nextStop.latitude), lng: parseFloat(nextStop.longitude) };
                                                                    } else if (nextStop?.locationId) {
                                                                        const match = pickupDropLocationData.find(loc => loc.id === nextStop?.locationId);
                                                                        if (match && match.latitude && match.longitude) {
                                                                            nextPoint = { lat: parseFloat(match.latitude), lng: parseFloat(match.longitude) };
                                                                        }
                                                                    }
                                                                }
                                                            } else if (index === stopIds.length - 1 && dropLatLng && typeof dropLatLng.lat === 'number' && typeof dropLatLng.lng === 'number') {
                                                                nextPoint = { lat: dropLatLng.lat, lng: dropLatLng.lng };
                                                            }
                                                            if (nextPoint && window.google && window.google.maps && window.google.maps.geometry) {
                                                                const distNext = window.google.maps.geometry.spherical.computeDistanceBetween(
                                                                    new window.google.maps.LatLng(nextPoint.lat, nextPoint.lng),
                                                                    new window.google.maps.LatLng(lat, lng)
                                                                );
                                                                if (distNext < 100) {
                                                                    setMessage('Selected stop is too close to the next location (< 100m)');
                                                                    showSnackbar(true);
                                                                    return; // Block selection
                                                                }
                                                            }
                                                        }

                                                        setStopIds(prevStops => {
                                                            const updated = [...prevStops];
                                                            updated[index] = {
                                                                ...updated[index],
                                                                locationId: e.target.value,
                                                                address: selectedLocation.address_name,
                                                                latitude: lat,
                                                                longitude: lng
                                                            };
                                                            // Reindex stop_id to keep sequence consistent
                                                            return updated.map((s, i) => ({ ...s, stop_id: i + 1 }));
                                                        });
                                                        setVehicleId('');
                                                        setVehicleType('');
                                                    }
                                                }
                                            }}
                                            displayEmpty
                                        >
                                            <MenuItem value="" disabled>
                                                <Typography sx={{ color: '#666' }}>Select Stop</Typography>
                                            </MenuItem>
                                            {pickupDropLocationData.map((location) => (
                                                <MenuItem key={location.id} value={location.id}>
                                                    {location.address_name}
                                                </MenuItem>
                                            ))}
                                        </Select>

                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                const stopIndexToRemove = index;
                                                console.log(`Removing stop at index ${stopIndexToRemove}`);
                                                handleRemoveStopIds(stopIndexToRemove);
                                            }}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                padding: 0, marginLeft:'2%',
                                                marginRight: '2%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                            aria-label={`Remove stop ${stop.stop_id}`}
                                        >
                                            <img 
                                                src={SubtractCircleSvg}
                                                style={{width:'28px',height:'28px'}}
                                                alt="Remove stop"
                                            />
                                        </button>
                                    </Grid2>
                                </Grid2>
                            ))}
                        </>
                    )}

                    {panel_customer_specific_address!=1 && (
                        <>
                            <Typography sx={{color: '#83888E', fontSize:'16px', marginTop:'1%'}}>Enter Locations</Typography>
                            <Grid2 container spacing={2} sx={{marginTop:'1%'}}>
                                <Grid2 item size={remove_add_stops == 1 ? 6 : 5}>
                                    <input
                                        ref={inputRef}
                                        type="text"
                                        placeholder=" Enter Pickup Location"
                                        style={{
                                            width:'100%', boxSizing: 'border-box',
                                            paddingLeft: '32px', // Add space for the icon on the left 
                                            backgroundImage: `url(${pickupMarker})`, // Replace with your icon URL
                                            backgroundPosition: '8px center', // Position the icon on the left side
                                            backgroundRepeat: 'no-repeat', // Prevent the icon from repeating
                                            backgroundSize: '20px 20px',
                                            height:'44px',
                                            borderRadius:'8px',
                                            border:'1px solid #E6F0FF'
                                        }}
                                        value={pickupLocation}
                                        onChange={(e) => setPickupLocation(e.target.value)}  // Optional: Update the state as user types
                                    />
                                    {/* <input type="number" placeholder="Enter Pickup Location" className='filterBtn' style={{width:'280px'}}/> */}
                                </Grid2>

                                <Grid2 item size={remove_add_stops == 1 ? 6 : 5}>
                                    <input
                                        ref={inputDropRef}
                                        type="text"
                                        placeholder=" Enter drop Location"
                                        style={{
                                            width:'100%', boxSizing: 'border-box',
                                            paddingLeft: '32px', // Add space for the icon on the left 
                                            backgroundImage: `url(${dropMarker})`, // Replace with your icon URL
                                            backgroundPosition: '8px center', // Position the icon on the left side
                                            backgroundRepeat: 'no-repeat', // Prevent the icon from repeating
                                            backgroundSize: '20px 20px',
                                            height:'44px',
                                            borderRadius:'8px',
                                            border:'1px solid #E6F0FF'
                                        }}
                                        value={dropLocation}
                                        onChange={(e) => setDropLocation(e.target.value)}  // Optional: Update the state as user types
                                    />
                                    {/* <input type="number" placeholder="Enter Drop Location" className='filterBtn' style={{width:'280px'}}/> */}
                                </Grid2>

                                {remove_add_stops!=1 && 
                                    <Grid2 
                                        item size={2}
                                        sx={{
                                            border:'1px solid #0065ff', 
                                            borderRadius:'8px',
                                            display:'flex', 
                                            alignItems:'center', 
                                            justifyContent:'center', 
                                            cursor:'pointer',
                                            '&:hover': { backgroundColor: '#f0f7ff' }
                                        }}
                                        onClick={handleAddStop}
                                    >
                                        <Typography sx={{color:'#0065ff', textAlign:'center'}}>Add Stop</Typography>
                                    </Grid2>
                                }
                            </Grid2>
                            
                            {/* Display stops */}
                            {stops.map((stop, index) => (
                                <Grid2 container key={stop.stop_id || `stop-${index}-${Date.now()}`} sx={{marginTop:'1%'}}>
                                    <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                        <span style={{
                                            display: 'inline-block',
                                            minWidth: 24,
                                            minHeight: 24,
                                            borderRadius: '50%',
                                            background: '#0065ff',
                                            color: '#fff',
                                            fontWeight: 500,
                                            textAlign: 'center',
                                            lineHeight: '24px',
                                            marginRight: 8
                                        }}>{stop.stop_id || index + 1}</span>
                                        <input
                                            ref={el => stopRefs.current[index] = el}
                                            type="text"
                                            placeholder={`Stop ${index + 1}`}
                                            className="filterBtn"
                                            style={{
                                                width: '504px', 
                                                height:'38px',
                                                paddingLeft: '32px',
                                                // backgroundImage: `url(${dropMarker})`,
                                                backgroundPosition: '8px center',
                                                // backgroundRepeat: 'no-repeat',
                                                backgroundSize: '20px 20px',
                                                border: selectedStopIndex === index ? '2px solid #0065FF' : 'inherit'
                                            }}
                                            value={stop.location}
                                            onChange={(e) => handleStopLocationChange(index, e.target.value)}
                                            onFocus={() => handleStopFocus(index)}
                                            onBlur={() => setSelectedStopIndex(null)}
                                        />

                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                // Capture the current index in this scope
                                                const stopIndexToRemove = index;
                                                console.log(`Removing stop at index ${stopIndexToRemove}`);
                                                // Use the captured index
                                                handleRemoveStop(stopIndexToRemove);
                                            }}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                padding: 0,
                                                marginRight: '2%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                            aria-label={`Remove stop ${index + 1}`}
                                        >
                                            <img 
                                                src={SubtractCircleSvg}
                                                style={{width:'28px',height:'28px'}}
                                                alt="Remove stop"
                                            />
                                        </button>
                                    </Grid2>
                                    {/* <Grid2 
                                        item 
                                        sx={{
                                            marginLeft:'1%', 
                                            border:'1px solid #ff0000', 
                                            borderRadius:'8px', 
                                            display:'flex', 
                                            alignItems:'center', 
                                            justifyContent:'center', 
                                            cursor:'pointer',
                                            padding: '0 10px',
                                            '&:hover': { backgroundColor: '#fff0f0' }
                                        }}
                                        onClick={() => handleRemoveStop(index)}
                                    >
                                        <Typography sx={{color:'#ff0000', textAlign:'center'}}>-</Typography>
                                    </Grid2> */}
                                </Grid2>
                            ))}
                        </>
                    )}

                    {modalWayPoints
                        .filter(waypt => waypt.address && waypt.address.trim() !== '')
                        .map((waypt, index) => (
                            <Grid2 
                                container 
                                key={waypt.stop_id || `stop-${index}-${Date.now()}`} 
                                sx={{marginTop: '1%', position: 'relative'}}
                            >
                                <Grid2 sx={{
                                    border: '1px solid #D1D1D1', 
                                    padding: '8px 12px', 
                                    borderRadius: '8px', 
                                    marginTop: '6px', 
                                    color: '#4E545D', 
                                    width: '100%'
                                }}>
                                    <Typography>
                                        <span style={{fontSize: '14px', color: '#0065ff', marginBottom: '8px'}}>
                                            Stop {waypt.stop_id} : {" "}
                                        </span> 
                                        {waypt.address}
                                    </Typography>
                                </Grid2>
                            </Grid2>
                        ))
                    }

                    <hr style={{background:'#f9f9f9',}}/>

                    {userByPhone && (
                        <>
                            {(vehicleType && pickupLatLng && dropLatLng && add_pool_users > 0) &&
                                <Grid2 container sx={{ borderRadius:'8px', marginTop:'2%', marginBottom:'1%', alignItems:'center', gap: 1, padding:'8px', backgroundColor:'#f9f9f9'}}>
                                    
                                    {additionalUserIds.map((u) => {
                                                        const stopId = userStopMapping[u.user_id] ?? userStopMapping[u.user_code];
                                                        
                                                        const stopAddress = (() => {
                                                            if (stopId === 0) {
                                                                const pickupLoc = pickupLocationData.find(loc => loc.id === pickupLocation);
                                                                return `Pickup: ${pickupLoc?.address_name || 'N/A'}`;
                                                            } else if (stopId === -1) {
                                                                const dropLoc = dropLocationData.find(loc => loc.id === dropLocation);
                                                                return `Drop: ${dropLoc?.address_name || 'N/A'}`;
                                                            } else if (stopId) {
                                                                const stop = modalPickupDropLocData.find(s => 
                                                                    s.id == stopId || 
                                                                    s.id?.toString() === stopId?.toString()
                                                                );
                                                                return `Stop : ${u.user_stop}` || `Stop ${stopId}`;
                                                            }
                                                            return 'Not assigned';
                                                        })();

                                                    return (
                                                        <Grid2 item key={u.user_id}>
                                                            <Box sx={{ 
                                                                display: 'flex', 
                                                                alignItems: 'center', 
                                                                gap: 1, 
                                                                px: 1.75, 
                                                                py: 0.75, 
                                                                border: '1px solid #E6F0FF', 
                                                                borderRadius: '16px', 
                                                                background: '#F9FBFF', 
                                                                flexWrap: 'wrap' 
                                                            }}>
                                                                <Box>
                                                                    <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#0065ff' }}>
                                                                        {u.user_name || 'User'} (ID: {u.user_id})
                                                                    </Typography>
                                                                    <Typography variant="caption" sx={{ color: '#6B7280', display: 'block', mt: 0.5 }}>
                                                                        {stopAddress}
                                                                    </Typography>
                                                                </Box>
                                                                <IconButton 
                                                                    size="small" 
                                                                    onClick={() => removeAddedClient(u.user_id)} 
                                                                    sx={{ p: 0.2, ml: 'auto' }}
                                                                >
                                                                    <CloseIcon sx={{ fontSize: 16 }} />
                                                                </IconButton>
                                                            </Box>
                                                        </Grid2>
                                                    );
                                                })}
                                    <Grid2 item size={2} sx={{marginLeft:additionalUserIds.length > 0 ?'auto':'inherit'}}>
                                        <Button
                                            sx={{
                                                height:'38px', width:'100px',
                                                borderRadius:'8px',
                                                border:'1px solid #000',
                                                color:'#000',
                                                textTransform:'none',
                                                fontSize:'14px'
                                            }} 
                                            onClick={handleOpenAddClientModal}
                                        >
                                            Add Client
                                        </Button>
                                    </Grid2>
                                </Grid2>
                            }

                            <Grid2 item container spacing={2} size={12} sx={{marginTop:'2%'}}>
                                <Grid2 item size={4}>
                                    <Box sx={{display: 'flex', flexDirection: 'column'}}>
                                        <Label style={{fontSize:'14px', color:'#4E545D', marginBottom: '8px'}}>User Name</Label>
                                        <Typography sx={{
                                            fontSize:'16px', 
                                            color:'#0065FF', 
                                            border:'1px solid #0065FF', 
                                            padding:'8px 12px', 
                                            borderRadius:'8px',
                                            // height: '42px',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                            {userByPhone.user_name}
                                        </Typography>
                                    </Box>
                                </Grid2>
                                <Grid2 item size={4} sx={{display: 'flex', flexDirection: 'column'}}>
                                    <Label style={{fontSize:'14px', color:'#4E545D', marginBottom: '8px'}}>Vehicle Type</Label>
                                    <Select
                                        value={vehicleId}
                                        onChange={(e) => handleChange(e.target.value)}
                                        displayEmpty
                                        sx={{
                                            width: '100%',
                                            height: '42px',
                                            borderRadius: '8px',
                                            backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'
                                        }}
                                    >
                                            <MenuItem value="">Select Vehicle</MenuItem>
                                            {vehicleDetails.map((vehicle) => (
                                                <MenuItem key={vehicle.vehicle_id} value={vehicle.vehicle_id}>
                                                    {vehicle.vehicle_name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    {/* </Box> */}
                                </Grid2>

                                {(vehicleType && dropLatLng && pickupLatLng) && (
                                    <Grid2 item size={4} sx={{display: 'flex', flexDirection: 'column'}}>
                                        <Label style={{fontSize:'14px', color:'#4E545D', marginBottom: '12px'}}> </Label>
                                        {((additionalUserIds.length <= 0 && add_pool_users) || !add_pool_users) &&
                                            <Button 
                                                sx={{
                                                    textTransform:'none', marginTop:'12px',
                                                    padding:'8px 32px', 
                                                    border:'1px solid #0065FF', 
                                                    backgroundColor:'#F3F8FF',
                                                    color:'#0065FF', 
                                                    width:'100%',
                                                    height: '42px',
                                                    borderRadius: '8px'
                                                }} 
                                                disabled={isScheduleDisabled}
                                                onClick={setAutoAsigningTrue}>
                                                Auto Assign Ride
                                            </Button>
                                        }
                                        

                                    </Grid2>
                                )}
                                        {hasCorporate && corporateFarePerRide && (
                                            <Grid2 item size={12} sx={{ mt: '1%', mb: '1%' }}>
                                                {isScheduleDisabled && (
                                                    <Box sx={{
                                                        width: 'auto',
                                                        border: '1px solid #FCA5A5',
                                                        backgroundColor: '#FEF2F2',
                                                        borderRadius: '8px',
                                                        px: 2, py: 1,
                                                        mb: 0.5,
                                                    }}>
                                                        <Typography sx={{ color: '#D14545', fontSize: '13px', fontWeight: 500 }}>
                                                            {scheduleDisabledReason}
                                                        </Typography>
                                                    </Box>
                                                )}

                                                <Box sx={{ display: 'flex', gap: 1.5 }}>
                                                    {[
                                                        { label: 'Remaining Balance', value: userRemainingBalance !== '' ? Number(userRemainingBalance).toFixed(2) : '--' },
                                                        { label: 'Remaining Trips', value: userRemainingTrips !== '' ? userRemainingTrips : '--' },
                                                        { label: 'Estimated Fare (this ride)', value: corporateFarePerRide !== '' ? Number(corporateFarePerRide).toFixed(2) : '--' },
                                                    ].map((item) => (
                                                        <Box key={item.label} sx={{
                                                            flex: 1,
                                                            minWidth: 0,
                                                            border: '1px solid #E6F0FF',
                                                            borderRadius: '10px',
                                                            backgroundColor: '#F9FBFF',
                                                            px: 2, py: 1.25,
                                                        }}>
                                                            <Typography sx={{ fontSize: '12px', color: '#6B7280', mb: 0.5, whiteSpace: 'nowrap' }}>
                                                                {item.label}
                                                            </Typography>
                                                            <Typography sx={{ fontSize: '18px', fontWeight: 600, color: '#0065FF' }}>
                                                                {item.value}
                                                            </Typography>
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Grid2>
                                        )}
                            </Grid2>
                        </>
                    )} 

                    </>
                )}
                <Grid2 item sx={{marginTop:'2%'}}>
                    {isLoaded ? (
                        <GoogleMap mapContainerStyle={containerStyle} center={initialcityCenter} zoom={9} onLoad={onLoad} onUnmount={onUnmount}>
                            
                            {pickupLatLng && (
                                <Marker position={pickupLatLng} title="Pickup Location" 
                                    icon={{
                                        url: pickupMarker,
                                        scaledSize: new window.google.maps.Size(30, 30)
                                    }}
                                />
                            )}
                            
                            {dropLatLng && (
                                <Marker position={dropLatLng} title="Drop Location" 
                                    icon={{
                                        url: dropMarker,
                                        scaledSize: new window.google.maps.Size(30, 30) 
                                    }} 
                                />
                            )}
                            
                            {/* Display markers for each stop that has coordinates */}
                            {stops.map((stop, index) => (
                                stop.latitude && stop.longitude && (
                                    <Marker 
                                        key={`stop-${index}`}
                                        position={{lat: stop.latitude, lng: stop.longitude}} 
                                        title={`Stop ${index + 1}`}
                                        icon={{
                                            // url: mapPin,
                                            scaledSize: new window.google.maps.Size(20, 20), // Make stop markers larger
                                            // labelOrigin: new window.google.maps.Point(13, 13),
                                            // anchor: new window.google.maps.Point(13, 26) // Anchor at bottom center
                                        }}
                                        label={{
                                            text: `${index + 1}`,
                                            color: 'white',
                                            fontSize: '12px',
                                            fontWeight: 'bold'
                                        }}
                                        zIndex={10} // Make stop markers appear above the polyline
                                    />
                                )
                            ))}
                            
                            {/* Google Maps Directions Polyline */}
                            {directions && (
                                <Polyline
                                    path={routePath}
                                    options={{
                                        strokeColor: '#0065FF',
                                        strokeWeight: 5,
                                        strokeOpacity: 0.8,
                                        clickable: false,
                                        zIndex: 5,
                                        geodesic: true,
                                        icons: [{
                                            icon: {
                                                path: window.google.maps.SymbolPath.FORWARD_OPEN_ARROW,
                                                scale: 4,
                                                strokeColor: '#0065FF',
                                                strokeWeight: 2
                                            },
                                            offset: '100%',
                                            repeat: '100px'
                                        }]
                                    }}
                                />
                            )}
                            
                            {/* {driversData.length > 0 && driversData.map((marker) => (
                                <Marker
                                    key={marker.driver_id}
                                    position={{ lat: marker.current_latitude, lng: marker.current_longitude }}
                                    title={marker.driver_name} // Tooltip text when hovering over the marker
                                    icon={{
                                        url: mapPin,
                                        scaledSize: new window.google.maps.Size(20, 20) 
                                    }}
                                />
                            ))} */}
                            {stopIds.map((stopId, index) => {
                                const matchingLocation = pickupDropLocationData.find(loc => loc.id === stopId?.locationId);
                                if (!matchingLocation || !matchingLocation.latitude || !matchingLocation.longitude) {
                                    return null;
                                }

                                const position = {
                                    lat: parseFloat(matchingLocation.latitude),
                                    lng: parseFloat(matchingLocation.longitude)
                                };

                                return (
                                    <Marker 
                                        key={`stop-${stopId.stop_id || index}`}
                                        position={position}
                                        title={`Stop ${index + 1}`}
                                        icon={{
                                            path: window.google.maps.SymbolPath.CIRCLE,
                                            fillColor: '#0065FF',
                                            fillOpacity: 1,
                                            strokeColor: 'white',
                                            strokeWeight: 2,
                                            scale: 10,
                                        }}
                                        label={{
                                            text: `${index + 1}`,
                                            color: 'white',
                                            fontSize: '12px',
                                            fontWeight: 'bold'
                                        }}
                                        zIndex={10}
                                    />
                                );
                            })}


                            {!isNearbyDrivers && driversData && driversData.length > 0 && driversData.map((marker) => {
                                return (
                                    <DriverLabelMarker
                                        key={marker.driver_id}
                                        marker={marker}
                                        mapPin={mapPin}
                                    />

                                );
                            })}

                            {isNearbyDrivers && driversData && driversData.length > 0 && driversData.map((marker) => {
                                
                                const vehicleIcon = marker.vehicle_type==1 ? CarMarker : marker.vehicle_type==2 ? BikeMarker : AutoMarker;
                                return (
                                    <DriverLabelMarker
                                        key={marker.driver_id}
                                        marker={marker}
                                        mapPin={vehicleIcon}
                                    />
                                );
                            })}

                        </GoogleMap>
                        
                    ): (<></>)}

                </Grid2>
                    
                </Grid2>
            </Grid2>


            {autoAssigning && fullScreenLoader && (
                <Box
                    sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent dark overlay
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1300, // Ensure it's above other elements
                    }}
                >
                    {/* Centered Modal Box */}
                    <Box
                        sx={{
                            backgroundColor: "#FFFFFF", // Modal background color
                            borderRadius: "16px", // Rounded corners
                            width: "400px", // Fixed width
                            padding: "24px", // Padding for internal spacing
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", // Box shadow for elevation
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center", // Center content horizontally
                            textAlign: "center", // Center text
                        }}
                    >
                        {/* Title */}
                        <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: "16px" }}>
                            Auto Assigning
                        </Typography>

                        {/* Subtext */}
                        <Typography sx={{ fontSize: "14px", color: "#6E6E6E", marginBottom: "24px" }}>
                            Please wait until the driver accepts the request.
                        </Typography>

                        {/* Lottie Animation */}
                        <Box
                            sx={{
                                width: "350px", // Adjust size of the Lottie animation
                                height: "200px",
                                marginBottom: "24px", // Space between Lottie and cancel button
                            }}
                        >
                            <Lottie animationData={loadingAnimation} loop={true} />
                        </Box>

                        {/* Cancel Button */}
                        <Typography
                            onClick={() => handleCancelAutoAssignModal()}
                            sx={{
                                cursor: "pointer",
                                color: "#0065FF", // Blue text color
                                fontWeight: "500", // Slightly bold text
                                fontSize: "14px",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline", // Add underline on hover
                                },
                            }}
                        >
                            Cancel
                        </Typography>
                    </Box>
                </Box>
            )}
            {autoAssigning && fullScreenLoader && !normalAssign && (
                <RideRequestComponent autoAssignParams={autoAssignParams} setFullScreenLoader={setFullScreenLoader} normalAssign={normalAssign} />
            )}

            {autoAssigning && fullScreenLoader && normalAssign && (
                <RideRequestComponent autoAssignParams={autoAssignParams} setFullScreenLoader={setFullScreenLoader} normalAssign={normalAssign} />
            )}

            {showForceAssignedSuccess && forceAssignData && (
                <Box
                    sx={{
                        position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center",
                        alignItems: "center", zIndex: 1300,
                    }}
                >
                    {/* Centered Modal Box */}
                    <Box
                        sx={{
                            backgroundColor: "#FFFFFF", borderRadius: "16px", width: "400px", padding: "24px",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", textAlign: "center",
                            display: "flex", flexDirection: "column", alignItems: "center",
                        }}
                    >
                        {/* Title */}
                        <img src={successIcon} alt="green check"/>

                        {/* Subtext */}
                        <Typography sx={{ fontSize: "24px", color: "#000", marginBottom: "14px" }}>
                            Ride Assigned.
                        </Typography>

                        <Typography sx={{ fontSize: "16px", color: "#83888E", marginBottom: "24px" }}>
                            Ride successfully assigned to the selected driver.
                        </Typography>

                        <Grid2 sx={{border:'1px solid #D1D5DB', padding:'8px', margin:'4px', borderRadius:'12px'}}>
                            <Grid2 sx={{backgroundColor:'#1A1E25', padding:'8px 16px', borderRadius:'8px', width:'340px', height:'40px'}}>
                                <span style={{color:'#83888E', fontSize:'12px'}}>Engagement ID </span>
                                <span style={{color:'#fff', fontSize:'16px'}}>{forceAssignData?.engagement_details?.engagement_id}</span>
                            </Grid2>

                            <Grid2 item container sx={{padding:'8px'}}>
                                <Grid2 item size={2}>
                                    {gridData.driver_image && (
                                        <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt={'driver'} src={forceAssignData?.driver_details?.driver_image}></Avatar>
                                    )}
                                    {!gridData.driver_image && (
                                        <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt={'driver'} src={altAvatar}></Avatar>
                                    )}
                                </Grid2>
                                <Grid2 item size={6}>
                                    <Grid2 item sx={{alignItems:'left'}}>
                                        <Typography sx={{color:'#83888E', fontSize:'14px', textAlign:'left'}}>{forceAssignData?.driver_details.driver_name}</Typography>
                                        <Typography sx={{color:'#1A1E25', fontSize:'16px', textAlign:'left'}}>ID: {forceAssignData?.driver_details.driver_id}</Typography>
                                    </Grid2>
                                </Grid2>
                                <Grid2 item size={2} sx={{marginTop:'4%'}}>
                                    <Typography sx={{color:'#0065FF', fontSize:'16px'}}>{forceAssignData?.driver_details?.phone_number}</Typography>
                                </Grid2>
                            </Grid2>

                            <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB'}} />

                            <Grid2 item container>
                                <Grid2 item size={2}>
                                    {forceAssignData.driver_details.vehicle_type==1 && (
                                        <Grid2><img src={vehicleTypeCar} alt="Ryde"/></Grid2>
                                    )}
                                    {forceAssignData.driver_details.vehicle_type==2 && (
                                        <Grid2><img src={vehicleTypeBike} alt="bike"/></Grid2>
                                    )}
                                    {forceAssignData.driver_details.vehicle_type==3 && (
                                        <Grid2><img src={vehicletypeAuto} alt="auto"/></Grid2>
                                    )}
                                </Grid2>
                                <Grid2 item size={6}>
                                    <Grid2 item>
                                        <Typography sx={{color:'#83888E', fontSize:'10px', textAlign:'left'}}>{forceAssignData?.driver_details.vehicle_name}</Typography>
                                        <Typography sx={{color:'#4E545D', fontSize:'12px', textAlign:'left', fontWeight:'400'}}>{forceAssignData?.driver_details.vehicle_no}</Typography>
                                    </Grid2>
                                </Grid2>
                                {/* <Grid2 item size={2} sx={{marginTop:'4%'}}>
                                    <Typography sx={{color:'#0065FF', fontSize:'16px'}}>62020202</Typography>
                                </Grid2> */}
                            </Grid2>

                            <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB'}} />

                            <Grid2 item container>
                                <Grid2 item size={3}>
                                    <Typography sx={{color:'#83888E', fontSize:'12px'}}>Payment Type</Typography>
                                    <Typography sx={{color:'#1A1E25', fontSize:'16px'}}>{forceAssignData?.engagement_details?.payment_mode == 1 ? 'CASH' : 'STRIPE'}</Typography>
                                </Grid2>

                                <Grid2 item size={3}>
                                    <Typography sx={{color:'#83888E', fontSize:'12px'}}>Fare</Typography>
                                    <Typography sx={{color:'#1A1E25', fontSize:'16px'}}>{forceAssignData?.engagement_details?.estimated_fare}</Typography>
                                </Grid2>
                            </Grid2>
                        </Grid2>

                        <Typography
                            onClick={handleCloseModal}
                            sx={{
                                cursor: "pointer",
                                color: "#0065FF", // Blue text color
                                fontWeight: "500", // Slightly bold text
                                fontSize: "14px",
                                textDecoration: "none", marginTop:'12px',
                                "&:hover": {
                                    textDecoration: "underline", // Add underline on hover
                                },
                            }}
                        >
                            Got It
                        </Typography>
                        
                    </Box>
                </Box>
            )}

            {orderCreated && (
                <Box sx={{
                    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1300,
                }}>
                    <Box sx={{
                        backgroundColor: '#FFF', borderRadius: '16px', width: 420, p: 3,
                        boxShadow: '0px 4px 10px rgba(0,0,0,0.25)', textAlign: 'center',
                        display: 'flex', flexDirection: 'column', alignItems: 'center',
                    }}>
                        <img src={successIcon} alt="success" />
                        <Typography sx={{ fontSize: 24, color: '#000', mt: 1, mb: 0.5 }}>Order Created</Typography>
                        <Typography sx={{ fontSize: 15, color: '#83888E', mb: 2.5 }}>
                            Your parcel order has been placed and is being assigned to a driver.
                        </Typography>

                        <Box sx={{ border: '1px solid #D1D5DB', borderRadius: '12px', p: 1, width: '100%' }}>
                            <Box sx={{ backgroundColor: '#1A1E25', borderRadius: '8px', px: 2, py: 1, textAlign: 'left' }}>
                                <span style={{ color: '#83888E', fontSize: 12 }}>Order ID </span>
                                <span style={{ color: '#fff', fontSize: 16 }}>
                                    {orderCreated?.engagement_details?.engagement_id ?? orderCreated?.trip_request_id ?? orderCreated?.request_id ?? '—'}
                                </span>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 1.5 }}>
                                <Box sx={{ textAlign: 'left' }}>
                                    <Typography sx={{ fontSize: 12, color: '#83888E' }}>Stops</Typography>
                                    <Typography sx={{ fontSize: 16, color: '#1A1E25' }}>{merchantParcelData.stops?.length || 0}</Typography>
                                </Box>
                                <Box sx={{ textAlign: 'right' }}>
                                    <Typography sx={{ fontSize: 12, color: '#83888E' }}>Estimated Fare</Typography>
                                    <Typography sx={{ fontSize: 16, color: '#1A1E25' }}>{estimatedFare}</Typography>
                                </Box>
                            </Box>
                        </Box>

                        <Button
                            onClick={() => { setOrderCreated(null); window.location.reload(); }}
                            variant="contained" disableElevation
                            sx={{ mt: 2.5, width: '100%', height: 44, borderRadius: '8px', textTransform: 'none', bgcolor: '#0065FF' }}
                        >
                            Done
                        </Button>
                    </Box>
                </Box>
            )}

            {ongoingRideCheck && (
                <Box
                    sx={{
                        position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center",
                        alignItems: "center", zIndex: 1300,
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: "#FFFFFF", borderRadius: "16px", width: "400px", padding: "24px",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", textAlign: "center", display: "flex", flexDirection: "column", 
                        }}
                    >
                        <img src={CarDriver} height="210px" width="210px" alt="No drivers found" style={{alignSelf:'center'}}/>
    
                        <Typography sx={{ fontSize: "20px", color: "#000", marginBottom: "14px" }}>
                            {ongoingRideCheckMessage}
                        </Typography>
    
                        <Typography
                            onClick={handleCloseOngoingRideCheckModal}
                            sx={{
                                cursor: "pointer",color: "#0065FF",fontWeight: "500",fontSize: "18px",textDecoration: "none",
                                "&:hover": {textDecoration: "underline"},
                            }}
                        >
                            OK
                        </Typography>
                    </Box>
                </Box>
            )}

            {/* Add Client Modal */}
            <Modal
                open={addClientModal}
                onClose={() => {
                    handleCloseAddClientModal()
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%, -50%)', width:{ xs:'90%', sm:520 }, bgcolor:'#FFFFFF', borderRadius:'12px', boxShadow:24, p:3, outline:'none' }}>
                    <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                        <Typography sx={{ fontSize:'18px', fontWeight:600, color:'#1A1E25' }}>Add Clients</Typography>
                        <IconButton aria-label="close" onClick={() => handleCloseAddClientModal()} sx={{ color:'#6B7280' }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: "#f1f5f9",
                            borderLeft: "4px solid #0065FF",
                            padding: "12px 16px",
                            borderRadius: "6px",
                            marginBottom: 2
                        }}
                        >
                        <Typography sx={{ fontSize: 14, color: "#334155" }}>
                            If the client is being picked up from the same location, click <strong>Add Client</strong>.
                        </Typography>

                        <Typography sx={{ fontSize: 14, color: "#334155", marginTop: "6px" }}>
                            Click <strong>Fetch Stop</strong> only when the pickup location is different.
                        </Typography>
                    </Box>

                    {clientId==188 && 
                        <Grid2 item container sx={{ alignItems:'center', mb:1 }}>
                            <Typography sx={{color:'#6B7280', fontSize:'14px'}}>Search by phone number</Typography>
                            <Switch
                                checked={!modalSearchByClient}
                                // onChange={() => setModalSearchByClient(!modalSearchByClient)}
                                onClick={handleModalSearchByClientToggle}
                            />
                        </Grid2>
                    }

                    <Grid2 container spacing={2} sx={{ mt:0.5 }}>
                        {!modalSearchByClient && 
                            <Grid2 item size={7.5}>
                                <PhoneInput
                                    defaultCountry={country_code || "IN"}
                                    style={{ height:'44px', fontSize:'16px', alignItems:'normal', width:'100%' }}
                                    placeholder=" Enter phone number"
                                    value={modalCustomerPhone}
                                    onChange={setModalCustomerPhone}
                                />
                            </Grid2>
                        }

                        {modalSearchByClient && 
                            <Grid2 item size={7.5}>
                                <TextField
                                    label="Enter Client ID"
                                    value={modalUserCodeSearch}
                                    onChange={(e) => setModalUserCodeSearch(e.target.value)}
                                    sx={{
                                        width: '100%',
                                        '& .MuiInputBase-root': { height: '44px', fontSize: '14px', alignItems: 'center' },
                                        '& .MuiInputLabel-root': {
                                            transform: 'translate(14px, 10px) scale(1)',
                                            '&.MuiInputLabel-shrink': { transform: 'translate(14px, -9px) scale(0.75)' },
                                        },
                                        '& .MuiInputBase-input': { padding: '8px 6px' },
                                    }}
                                />
                            </Grid2>
                        }

                        <Grid2 item size={4.5}>
                            <Button sx={{textTransform:'none', borderRadius:'8px', width:'100%',
                            color:'#0065FF', height: '44px', border:'1px solid #0065FF'}} onClick={searchAddClient}>
                                Fetch Stops
                            </Button>
                        </Grid2>

                        <Grid2 item size={7.5}>
                            <Select 
                                value={userStopMapping[modalUserCodeSearch] === 0 ? 'pickup' : 
                                            userStopMapping[modalUserCodeSearch] === -1 ? 'drop' : 
                                            userStopMapping[modalUserCodeSearch] || ''}
                                    onChange={(e) => {
                                const stopValue = e.target.value;
                                
                                setUserStopMapping(prev => {
                                    const newMapping = { ...prev };
                                    
                                    if (stopValue === 'pickup') {
                                        newMapping[modalUserCodeSearch] = 0;
                                    } else if (stopValue === 'drop') {
                                        newMapping[modalUserCodeSearch] = -1;
                                    } else if (parseInt(stopValue) > 0) {
                                        newMapping[modalUserCodeSearch] = parseInt(stopValue);
                                    } else {
                                        delete newMapping[modalUserCodeSearch];
                                    }
                                    
                                    return newMapping;
                                });
                            }}
                                style={{width: '100%', height: '44px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}
                                disabled={!modalUserCodeSearch && !modalCustomerPhone}
                                displayEmpty
                            >
                                <MenuItem value="">Select Stop</MenuItem>
                                {pickupLocation && (
                                    <MenuItem value="pickup">
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            {/* <img src={pickupMarker} alt="pickup" width={16} /> */}
                                            <span>Pickup: {pickupLocationData.find(loc => loc.id === pickupLocation)?.address_name}</span>
                                        </Box>
                                    </MenuItem>
                                )}
                                
                                {/* Show selected drop location if exists */}
                                {dropLocation && (
                                    <MenuItem value="drop">
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            {/* <img src={dropMarker} alt="drop" width={16} /> */}
                                            <span>Drop: {dropLocationData.find(loc => loc.id === dropLocation)?.address_name}</span>
                                        </Box>
                                    </MenuItem>
                                )}
                                
                                {modalPickupDropLocData.length > 0 && modalPickupDropLocData[0]?.address && modalPickupDropLocData
                                    .filter(stop => stop.address && stop.address.trim() !== '')
                                    .map((stop, index) => (
                                        <MenuItem key={stop.id} value={stop.id}>
                                            {stop.address_name} <span style={{color:'#6B7280', fontSize:'12px'}}>(ID: {stop.id})</span>
                                        </MenuItem>
                                    ))
                                }
    
                                {/* If no stops with addresses, try to use stopIds with locationId */}
                                {(!stops.length || !stops[0]?.address) && stopIds.length > 0 && stopIds[0]?.locationId && 
                                    stopIds
                                        .filter(stop => stop.locationId && stop.locationId !== '')
                                        .map((stop) => {
                                            const matchingLocation = modalPickupDropLocData.find(loc => loc.id === stop.locationId);
                                            return (
                                                <MenuItem key={`stop-${stop.stop_id}`} value={stop.stop_id}>
                                                    {`${matchingLocation?.address_name || 'Stop'} (Stop ${stop.stop_id})`}
                                                </MenuItem>
                                            );
                                        })
                                }
                            </Select>
                        </Grid2>

                        <Grid2 item size={4.5}>
                            <Button
                                onClick={addingClient}
                                disabled={Boolean(seatCount) && additionalUserIds.length >= Number(seatCount)-1}
                                sx={{
                                    textTransform:'none', borderRadius:'8px', width:'100%', height:'44px',
                                    backgroundColor: '#0065FF', color:'#FFFFFF',
                                    '&:hover': { backgroundColor:'#0856d3' },
                                    '&.Mui-disabled': { backgroundColor:'#E5E7EB', color:'#9CA3AF' }
                                }}
                            >
                                Add Client
                            </Button>
                        </Grid2>
                    </Grid2>

                    {(additionalUserIds && additionalUserIds.length > 0) && (
                        <Box sx={{ mt: 2 }}>
                            <Typography sx={{ mb: 1, fontSize: '14px', color: '#4E545D' }}>
                                Added clients: {additionalUserIds.length}{seatCount ? ` / ${seatCount-1}` : ''}
                            </Typography>
                            <Grid2 container spacing={1}>
                                {additionalUserIds.map((u) => {
                                    const stopId = userStopMapping[u.user_id] ?? userStopMapping[u.user_code];
                                    const stopAddress = (() => {
                                        if (stopId === 0) {
                                            // For pickup
                                            const pickupLoc = pickupLocationData.find(loc => loc.id === pickupLocation);
                                            return `Pickup: ${pickupLoc?.address_name || 'N/A'}`;
                                        } else if (stopId === -1) {
                                            // For drop
                                            const dropLoc = dropLocationData.find(loc => loc.id === dropLocation);
                                            return `Drop: ${dropLoc?.address_name || 'N/A'}`;
                                        } else if (u.user_stop) {
                                            // For regular stops
                                            const stop = modalPickupDropLocData.find((s) => 
                                                s.id == u.user_stop || 
                                                s.id?.toString() === u.user_stop?.toString()
                                            );
                                            return stop?.address_name || `Stop ${u.user_stop}`;
                                        }
                                        return 'Not assigned';
                                    })();

                                    return (
                                        <Grid2 item key={u.user_id}>
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                gap: 1, 
                                                px: 1.75, 
                                                py: 0.75, 
                                                border: '1px solid #E6F0FF', 
                                                borderRadius: '16px', 
                                                background: '#F9FBFF', 
                                                flexWrap: 'wrap' 
                                            }}>
                                                <Box>
                                                    <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#0065ff' }}>
                                                        {u.user_name || 'User'} (ID: {u.user_id})
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: '#6B7280', display: 'block', mt: 0.5 }}>
                                                        {stopAddress}
                                                    </Typography>
                                                </Box>
                                                <IconButton 
                                                    size="small" 
                                                    onClick={() => removeAddedClient(u.user_id)} 
                                                    sx={{ p: 0.2, ml: 'auto' }}
                                                >
                                                    <CloseIcon sx={{ fontSize: 16 }} />
                                                </IconButton>
                                            </Box>
                                        </Grid2>
                                    );
                                })}
                            </Grid2>
                        </Box>
                    )}

                    <Button
                        onClick={handleCloseAddClientModal}
                        sx={{
                            textTransform:'none', borderRadius:'8px', width:'100%', mt:3, height:'44px',
                            backgroundColor: '#F3F4F6', color:'#111827',
                            '&:hover': { backgroundColor:'#E5E7EB' }
                        }}
                    >
                        Done
                    </Button>
                </Box>
            </Modal>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleCloseSnackbar} message={message} />
        
                
        </div>
    );
}

export default Dispatcher;